import type { LocaleCode } from "./routing";

export type PageMetaCopy = {
  title: string;
  description: string;
};

type TranslatedLocale = Exclude<LocaleCode, "en-ca">;

const coreMeta: Record<TranslatedLocale, Record<string, PageMetaCopy>> = {
  "zh-cn": {
    "/": {
      title: "Revolin Roofing｜大温哥华专业屋顶服务",
      description:
        "为大温哥华业主提供屋顶更换、维修及专业屋顶系统服务，重视细致评估与清晰书面工程范围。",
    },
    "/services": {
      title: "大温哥华屋顶服务｜Revolin Roofing",
      description: "了解屋顶更换、维修、沥青瓦、金属屋顶、低坡屋顶以及检查维护等服务类别。",
    },
    "/about": {
      title: "关于 Revolin Roofing｜Revolin Group 旗下公司",
      description: "了解 Revolin Roofing 如何为大温哥华住宅进行屋顶评估、制定书面范围并协调项目。",
    },
    "/before-after": {
      title: "屋顶施工前后图库｜Revolin Roofing",
      description:
        "探索 Revolin Roofing 在大温哥华的施工前后图库：漏水维修、沥青瓦、金属、雪松木瓦与平屋顶改造，服务低陆平原业主。",
    },
    "/service-areas": {
      title: "大温哥华屋顶服务区域｜Revolin Roofing",
      description:
        "查看 Revolin Roofing 在大温哥华和低陆平原已确认的服务区域；这些区域并不代表分公司地址。",
    },
    "/faq": {
      title: "屋顶常见问题｜Revolin Roofing",
      description: "了解屋顶评估、维修、更换、系统选择、工程范围及大温哥华气候相关问题。",
    },
    "/contact": {
      title: "联系 Revolin Roofing｜申请屋顶评估",
      description: "联系 Revolin Roofing，咨询已确认服务区域内的屋顶评估、维修或更换需求。",
    },
    "/privacy": {
      title: "隐私政策｜Revolin Roofing",
      description: "了解 Revolin Roofing 如何处理网站咨询、归因信息及通过本网站提交的个人信息。",
    },
    "/terms": {
      title: "网站使用条款｜Revolin Roofing",
      description: "阅读 Revolin Roofing 网站及其一般屋顶教育内容的使用条款。",
    },
    "/services/emergency-roof-leak-repair": {
      title: "紧急屋顶漏水维修 | Revolin Roofing",
      description:
        "优先漏水诊断，在排期允许时当日到场，针对水从大温哥华住宅屋顶系统进入的情况，进行临时或永久性局部维修。",
    },
    "/services/flashing-roof-penetration-repair": {
      title: "泛水 / 屋顶穿透点维修 | Revolin Roofing",
      description:
        "维修烟囱、墙体、通风口、管道护套及其他屋顶穿透点泛水，这些是大温哥华屋顶常见的进水位置。",
    },
    "/services/moss-removal-roof-gutter": {
      title: "除苔藓 + 屋顶/天沟套餐 | Revolin Roofing",
      description:
        "为大温哥华住宅提供除苔藓、清理杂物、天沟清洁和目视屋顶检查，应对有机生长和堵塞排水加速屋顶磨损的问题。",
    },
    "/services/asphalt-shingle-replacement": {
      title: "沥青瓦屋顶更换 | Revolin Roofing",
      description: "为大温哥华陡坡住宅提供完整的沥青瓦拆除、垫层、瓦片、泛水整合及废料清运。",
    },
    "/services/roof-health-check-maintenance": {
      title: "屋顶健康检查与维护 | Revolin Roofing",
      description: "检查、拍照、少量密封胶或维护工作，以及供规划参考的屋顶状况报告。",
    },
    "/services/shingle-spot-repair": {
      title: "沥青瓦局部维修 | Revolin Roofing",
      description: "在周边现场仍可使用时，维修缺失、风损、开裂或其他损坏的沥青瓦局部区域。",
    },
    "/services/gutter-cleaning-downspout-flush": {
      title: "天沟清洁 + 落水管冲洗 | Revolin Roofing",
      description: "清洁天沟并冲洗落水管，使檐口排水在大温哥华降雨中正常工作。",
    },
    "/services/storm-tarping-emergency-dry-in": {
      title: "暴风雨防水布 / 紧急临时防水 | Revolin Roofing",
      description: "在风、树或暴风雨损坏后、永久屋顶工程进行前的临时防水。",
    },
    "/services/skylight-leak-flashing-repair": {
      title: "天窗漏水 / 泛水维修 | Revolin Roofing",
      description: "维修或重新泛水漏水天窗及周围屋面。",
    },
    "/services/chimney-flashing-repair": {
      title: "烟囱泛水维修 | Revolin Roofing",
      description: "大温哥华屋顶上 step flashing、counter-flashing 及烟囱相关漏水修正。",
    },
    "/services/gutter-replacement": {
      title: "天沟更换 | Revolin Roofing",
      description: "无缝铝天沟和落水管更换，确保檐口排水可靠。",
    },
    "/services/gutter-guard-installation": {
      title: "天沟滤网安装 | Revolin Roofing",
      description: "为树木繁茂物业减少落叶、苔藓和杂物堵塞频率的防护系统。",
    },
    "/services/roof-ventilation-upgrade": {
      title: "屋顶通风升级 | Revolin Roofing",
      description: "箱体通风口、ridge vent、檐口进气和阁楼气流修正，支持屋顶和阁楼性能。",
    },
    "/services/fascia-soffit-repair-replacement": {
      title: "封檐板 + 檐口底板维修 / 更换 | Revolin Roofing",
      description:
        "维修或更换腐烂或损坏的封檐板（fascia）、檐口底板（soffit）及支撑天沟和边缘细部的檐口组件。",
    },
    "/services/cedar-shake-repair-restoration": {
      title: "雪松木瓦维修 / 修复 | Revolin Roofing",
      description: "更换损坏雪松木瓦，并清洁或修复高端木屋顶的局部区域。",
    },
    "/services/flat-low-slope-roof-repair": {
      title: "平屋顶 / 低坡屋顶维修 | Revolin Roofing",
      description: "平屋顶和低坡屋顶上 SBS、热熔、TPO/EPDM 补丁、泛水和穿透点维修。",
    },
    "/services/metal-roof-repair-maintenance": {
      title: "金属屋顶维修 / 维护 | Revolin Roofing",
      description: "金属屋面系统的紧固件、泛水、密封胶、板材和穿透点维修。",
    },
    "/services/cedar-shake-roof-replacement": {
      title: "雪松木瓦屋顶更换 | Revolin Roofing",
      description: "为有意保留木屋顶建筑特色的住宅提供完整高端雪松木瓦重铺。",
    },
    "/services/metal-roof-replacement": {
      title: "金属屋顶更换 | Revolin Roofing",
      description: "为适合的陡坡建筑提供直立锁边或其他高端金属重铺。",
    },
    "/services/flat-roof-replacement-sbs-tpo-pvc": {
      title: "平屋顶更换：SBS / TPO / PVC | Revolin Roofing",
      description: "使用 SBS、TPO、PVC 或其他指定膜材系统，完成住宅或商业低坡屋顶的整体重铺。",
    },
  },
  "zh-tw": {
    "/": {
      title: "Revolin Roofing｜大溫哥華專業屋頂服務",
      description:
        "為大溫哥華屋主提供屋頂更換、維修及專業屋頂系統服務，重視細緻評估與清楚的書面工程範圍。",
    },
    "/services": {
      title: "大溫哥華屋頂服務｜Revolin Roofing",
      description: "了解屋頂更換、維修、瀝青瓦、金屬屋頂、低坡屋頂以及檢查維護等服務類別。",
    },
    "/about": {
      title: "關於 Revolin Roofing｜Revolin Group 旗下公司",
      description: "了解 Revolin Roofing 如何為大溫哥華住宅進行屋頂評估、制定書面範圍並協調專案。",
    },
    "/before-after": {
      title: "屋頂施工前後圖庫｜Revolin Roofing",
      description:
        "探索 Revolin Roofing 在大溫哥華的施工前後圖庫：漏水維修、瀝青瓦、金屬、雪松木瓦與平屋頂改造，服務低陸平原業主。",
    },
    "/service-areas": {
      title: "大溫哥華屋頂服務區域｜Revolin Roofing",
      description:
        "查看 Revolin Roofing 在大溫哥華和低陸平原已確認的服務區域；這些區域並不代表分公司地址。",
    },
    "/faq": {
      title: "屋頂常見問題｜Revolin Roofing",
      description: "了解屋頂評估、維修、更換、系統選擇、工程範圍及大溫哥華氣候相關問題。",
    },
    "/contact": {
      title: "聯絡 Revolin Roofing｜申請屋頂評估",
      description: "聯絡 Revolin Roofing，諮詢已確認服務區域內的屋頂評估、維修或更換需求。",
    },
    "/privacy": {
      title: "隱私權政策｜Revolin Roofing",
      description: "了解 Revolin Roofing 如何處理網站諮詢、歸因資訊及透過本網站提交的個人資料。",
    },
    "/terms": {
      title: "網站使用條款｜Revolin Roofing",
      description: "閱讀 Revolin Roofing 網站及其一般屋頂教育內容的使用條款。",
    },
    "/services/emergency-roof-leak-repair": {
      title: "緊急屋頂漏水維修 | Revolin Roofing",
      description:
        "優先漏水診斷，在排期允許時當日到場，針對水從大溫哥華住宅屋頂系統進入的情況，進行臨時或永久性局部維修。",
    },
    "/services/flashing-roof-penetration-repair": {
      title: "泛水 / 屋頂穿透點維修 | Revolin Roofing",
      description:
        "維修煙囪、牆體、通風口、管道防水套及其他屋頂穿透點泛水，這些是大溫哥華屋頂常見的進水位置。",
    },
    "/services/moss-removal-roof-gutter": {
      title: "苔蘚清除＋屋頂／檐溝組合維護 | Revolin Roofing",
      description:
        "苔蘚處理、雜物清除、檐溝清潔及屋頂目視檢查，適用於有機生長和排水堵塞加速屋面磨損的大溫哥華住宅。",
    },
    "/services/asphalt-shingle-replacement": {
      title: "瀝青瓦屋頂更換 | Revolin Roofing",
      description: "為大溫哥華陡坡住宅提供完整的瀝青瓦拆除、墊層、瓦片、泛水整合及廢料清運。",
    },
    "/services/roof-health-check-maintenance": {
      title: "屋頂健康檢查與維護 | Revolin Roofing",
      description: "檢查、拍照、少量密封膠或維護工作，以及供規劃參考的屋頂狀況報告。",
    },
    "/services/shingle-spot-repair": {
      title: "瀝青瓦局部維修 | Revolin Roofing",
      description: "在周邊屋面仍可使用時，對缺失、風損、開裂或其他損壞的瀝青瓦進行局部維修。",
    },
    "/services/gutter-cleaning-downspout-flush": {
      title: "檐溝清潔＋落水管沖洗 | Revolin Roofing",
      description: "清潔檐溝並沖洗落水管，使檐口排水在大溫哥華降雨時正常運作。",
    },
    "/services/storm-tarping-emergency-dry-in": {
      title: "暴風雨鋪布／緊急防雨封蓋 | Revolin Roofing",
      description: "風災、樹木撞擊或暴風雨損壞後的臨時防水，直至可進行永久屋頂工程。",
    },
    "/services/skylight-leak-flashing-repair": {
      title: "天窗漏水／泛水維修 | Revolin Roofing",
      description: "維修或重做漏水天窗及其周邊屋面的泛水。",
    },
    "/services/chimney-flashing-repair": {
      title: "煙囪泛水維修 | Revolin Roofing",
      description: "大溫哥華屋頂上踏步泛水、反泛水及煙囪相關漏水的修正。",
    },
    "/services/gutter-replacement": {
      title: "檐溝更換 | Revolin Roofing",
      description: "無縫鋁檐溝和落水管更換，確保檐口排水可靠。",
    },
    "/services/gutter-guard-installation": {
      title: "檐溝防護網安裝 | Revolin Roofing",
      description: "減少樹木密集物業上葉片、苔蘚和雜物堵塞頻率的防護系統。",
    },
    "/services/roof-ventilation-upgrade": {
      title: "屋頂通風升級 | Revolin Roofing",
      description: "箱式通風口、屋脊通風、檐口進氣及閣樓氣流修正，支持屋頂與閣樓性能。",
    },
    "/services/fascia-soffit-repair-replacement": {
      title: "封檐板＋檐口底板維修／更換 | Revolin Roofing",
      description: "維修或更換腐朽或損壞的封檐板、檐口底板和支撐檐溝的檐口構件。",
    },
    "/services/cedar-shake-repair-restoration": {
      title: "雪松木瓦維修／復原 | Revolin Roofing",
      description: "在高端木質屋頂上更換損壞雪松木瓦，並清潔或復原局部區域。",
    },
    "/services/flat-low-slope-roof-repair": {
      title: "平／低坡屋頂維修 | Revolin Roofing",
      description: "平屋頂和低坡屋頂上 SBS、熱熔、TPO/EPDM 補片、泛水和穿透點維修。",
    },
    "/services/metal-roof-repair-maintenance": {
      title: "金屬屋頂維修／維護 | Revolin Roofing",
      description: "金屬屋面系統的緊固件、泛水、密封膠、板材和穿透點維修。",
    },
    "/services/cedar-shake-roof-replacement": {
      title: "雪松木瓦屋頂更換 | Revolin Roofing",
      description: "為有意保留木質屋頂建築特色的住宅提供完整高端雪松木瓦重鋪。",
    },
    "/services/metal-roof-replacement": {
      title: "金屬屋頂更換 | Revolin Roofing",
      description: "為適合的陡坡建築提供直立鎖邊或其他高端金屬重鋪。",
    },
    "/services/flat-roof-replacement-sbs-tpo-pvc": {
      title: "平屋頂更換：SBS / TPO / PVC | Revolin Roofing",
      description: "使用 SBS、TPO、PVC 或其他指定膜材系統，完成住宅或商業低坡屋頂的整體重鋪。",
    },
  },
  "pa-in": {
    "/": {
      title: "Revolin Roofing | ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੀਆਂ ਰੂਫਿੰਗ ਸੇਵਾਵਾਂ",
      description:
        "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੇ ਘਰਾਂ ਲਈ ਛੱਤ ਬਦਲਣ, ਮੁਰੰਮਤ ਅਤੇ ਰੂਫਿੰਗ ਸਿਸਟਮਾਂ ਬਾਰੇ ਵਿਸਥਾਰਪੂਰਵਕ ਜਾਂਚ ਅਤੇ ਸਪਸ਼ਟ ਲਿਖਤੀ ਕਾਰਜ-ਖੇਤਰ।",
    },
    "/services": {
      title: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਰੂਫਿੰਗ ਸੇਵਾਵਾਂ | Revolin Roofing",
      description:
        "ਛੱਤ ਬਦਲਣ, ਮੁਰੰਮਤ, ਐਸਫਾਲਟ ਸ਼ਿੰਗਲ, ਮੈਟਲ, ਘੱਟ ਢਲਾਣ ਵਾਲੀ ਛੱਤ ਅਤੇ ਜਾਂਚ-ਸੰਭਾਲ ਦੀਆਂ ਸੇਵਾਵਾਂ ਵੇਖੋ।",
    },
    "/about": {
      title: "Revolin Roofing ਬਾਰੇ | Revolin Group ਦੀ ਕੰਪਨੀ",
      description:
        "ਜਾਣੋ ਕਿ Revolin Roofing ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੇ ਘਰਾਂ ਲਈ ਜਾਂਚ, ਲਿਖਤੀ ਕਾਰਜ-ਖੇਤਰ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਤਾਲਮੇਲ ਕਿਵੇਂ ਕਰਦੀ ਹੈ।",
    },
    "/before-after": {
      title: "ਛੱਤ ਪਹਿਲਾਂ-ਬਾਅਦ ਗੈਲਰੀ | Revolin Roofing",
      description:
        "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਵਿੱਚ Revolin Roofing ਦੀਆਂ ਪਹਿਲਾਂ-ਬਾਅਦ ਗੈਲਰੀਆਂ ਵੇਖੋ: ਲੀਕ ਮੁਰੰਮਤ, ਐਸਫਾਲਟ, ਮੈਟਲ, ਸੀਡਰ ਅਤੇ ਫਲੈਟ-ਰੂਫ ਤਬਦੀਲੀਆਂ ਲੋਅਰ ਮੇਨਲੈਂਡ ਘਰ-ਮਾਲਕਾਂ ਲਈ।",
    },
    "/service-areas": {
      title: "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਰੂਫਿੰਗ ਸੇਵਾ ਖੇਤਰ | Revolin Roofing",
      description:
        "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਅਤੇ ਲੋਅਰ ਮੇਨਲੈਂਡ ਵਿੱਚ ਪੁਸ਼ਟੀ ਕੀਤੇ ਸੇਵਾ ਖੇਤਰ ਵੇਖੋ; ਇਹ ਸ਼ਾਖਾ ਦਫ਼ਤਰਾਂ ਦੇ ਪਤੇ ਨਹੀਂ ਹਨ।",
    },
    "/faq": {
      title: "ਰੂਫਿੰਗ ਸਵਾਲ ਅਤੇ ਜਵਾਬ | Revolin Roofing",
      description:
        "ਛੱਤ ਦੀ ਜਾਂਚ, ਮੁਰੰਮਤ, ਬਦਲੀ, ਸਿਸਟਮ ਚੋਣ, ਕਾਰਜ-ਖੇਤਰ ਅਤੇ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੀਆਂ ਹਾਲਤਾਂ ਬਾਰੇ ਜਵਾਬ।",
    },
    "/contact": {
      title: "Revolin Roofing ਨਾਲ ਸੰਪਰਕ ਕਰੋ | ਛੱਤ ਦੀ ਜਾਂਚ ਮੰਗੋ",
      description:
        "ਪੁਸ਼ਟੀ ਕੀਤੇ ਸੇਵਾ ਖੇਤਰ ਵਿੱਚ ਛੱਤ ਦੀ ਜਾਂਚ, ਮੁਰੰਮਤ ਜਾਂ ਬਦਲੀ ਬਾਰੇ Revolin Roofing ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
    },
    "/privacy": {
      title: "ਪਰਦੇਦਾਰੀ ਨੀਤੀ | Revolin Roofing",
      description:
        "ਜਾਣੋ ਕਿ Revolin Roofing ਵੈੱਬਸਾਈਟ ਪੁੱਛਗਿੱਛ, ਐਟ੍ਰਿਬਿਊਸ਼ਨ ਜਾਣਕਾਰੀ ਅਤੇ ਦਿੱਤੀ ਨਿੱਜੀ ਜਾਣਕਾਰੀ ਨੂੰ ਕਿਵੇਂ ਸੰਭਾਲਦੀ ਹੈ।",
    },
    "/terms": {
      title: "ਵੈੱਬਸਾਈਟ ਦੀਆਂ ਸ਼ਰਤਾਂ | Revolin Roofing",
      description: "Revolin Roofing ਵੈੱਬਸਾਈਟ ਅਤੇ ਆਮ ਰੂਫਿੰਗ ਜਾਣਕਾਰੀ ਦੀ ਵਰਤੋਂ ਲਈ ਸ਼ਰਤਾਂ ਪੜ੍ਹੋ।",
    },
    "/services/emergency-roof-leak-repair": {
      title: "ਐਮਰਜੈਂਸੀ ਛੱਤ ਲੀਕ ਮੁਰੰਮਤ | Revolin Roofing",
      description:
        "ਤਰਜੀਹੀ ਲੀਕ ਨਿਦਾਨ, ਸਮੇਂ-ਸਾਰਣੀ ਮੁਤਾਬਕ ਉਸੇ ਦਿਨ, ਜਦੋਂ ਪਾਣੀ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਘਰ ਵਿੱਚ ਛੱਤ ਅਸੈਂਬਲੀ ਰਾਹੀਂ ਦਾਖਲ ਹੋ ਰਿਹਾ ਹੋਵੇ ਤਾਂ ਅਸਥਾਈ ਜਾਂ ਸਥਾਈ ਸਥਾਨਕ ਮੁਰੰਮਤ ਨਾਲ।",
    },
    "/services/flashing-roof-penetration-repair": {
      title: "ਫਲੈਸ਼ਿੰਗ / ਛੱਤ ਪ੍ਰਵੇਸ਼ ਮੁਰੰਮਤ | Revolin Roofing",
      description:
        "ਚਿਮਨੀ, ਕੰਧ, ਵੈਂਟ, ਪਾਈਪ ਬੂਟ ਅਤੇ ਹੋਰ ਛੱਤ ਪ੍ਰਵੇਸ਼ਾਂ 'ਤੇ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ ਜਿੱਥੇ ਪਾਣੀ ਅਕਸਰ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਛੱਤਾਂ ਵਿੱਚ ਦਾਖਲ ਹੁੰਦਾ ਹੈ।",
    },
    "/services/moss-removal-roof-gutter": {
      title: "ਮੌਸ ਹਟਾਉਣਾ + ਛੱਤ/ਗਟਰ | Revolin Roofing",
      description:
        "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਘਰਾਂ ਲਈ ਮੌਸ ਹਟਾਉਣਾ, ਮਲਬਾ ਸਫਾਈ, ਗਟਰ ਸਫਾਈ ਅਤੇ ਛੱਤ ਦੀ visual ਜਾਂਚ: organic growth ਅਤੇ blocked drainage ਘਿਸਾਈ ਤੇਜ਼ ਕਰਦੇ ਹਨ।",
    },
    "/services/asphalt-shingle-replacement": {
      title: "ਆਰਕੀਟੈਕਚਰਲ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਬਦਲਣਾ | Revolin Roofing",
      description:
        "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੇ ਢਲਾਣ ਵਾਲੇ ਘਰਾਂ ਲਈ ਪੂਰੀ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਟੀਅਰ-ਆਫ, ਅੰਡਰਲੇਮੈਂਟ, ਸ਼ਿੰਗਲ, ਫਲੈਸ਼ਿੰਗ ਏਕੀਕਰਣ ਅਤੇ ਨਿਪਟਾਰਾ।",
    },
    "/services/roof-health-check-maintenance": {
      title: "ਛੱਤ ਸਿਹਤ ਜਾਂਚ + ਰੱਖ-ਰਖਾਅ | Revolin Roofing",
      description:
        "ਨਿਰੀਖਣ, ਫੋਟੋ, ਛੋਟਾ ਸੀਲੈਂਟ ਜਾਂ ਰੱਖ-ਰਖਾਅ ਕੰਮ ਅਤੇ ਸੂਚਿਤ ਯੋਜਨਾ ਲਈ ਛੱਤ ਸਥਿਤੀ ਰਿਪੋਰਟ।",
    },
    "/services/shingle-spot-repair": {
      title: "ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਸਥਾਨਕ ਮੁਰੰਮਤ | Revolin Roofing",
      description:
        "ਜਦੋਂ ਆਲੇ-ਦੁਆਲੇ ਦਾ ਫੀਲਡ ਅਜੇ ਵੀ ਵਰਤੋਂਯੋਗ ਹੋਵੇ ਤਾਂ ਗੁੰਮ, ਹਵਾ-ਨੁਕਸਾਨ, ਕਰੈਕ ਜਾਂ ਹੋਰ ਖਰਾਬ ਅਸਫਾਲਟ ਸ਼ਿੰਗਲ ਜ਼ੋਨਾਂ ਦੀ ਮੁਰੰਮਤ।",
    },
    "/services/gutter-cleaning-downspout-flush": {
      title: "ਗਟਰ ਸਫਾਈ + ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ | Revolin Roofing",
      description:
        "ਗਟਰ ਸਾਫ਼ ਕਰੋ ਅਤੇ ਡਾਊਨਸਪਾਊਟ ਫਲੱਸ ਕਰੋ ਤਾਂ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਬਾਰਿਸ਼ ਵਿੱਚ ਈਵ ਡrerਨੇਜ ਠੀਕ ਕੰਮ ਕਰੇ।",
    },
    "/services/storm-tarping-emergency-dry-in": {
      title: "ਤੂਫਾਨ ਤਰਪਾਲ / ਐਮਰਜੈਂਸੀ ਡ੍ਰਾਈ-ਇਨ | Revolin Roofing",
      description:
        "ਹਵਾ, ਰੁੱਖ ਜਾਂ ਤੂਫਾਨ ਨੁਕਸਾਨ ਤੋਂ ਬਾਅਦ, ਸਥਾਈ ਛੱਤ ਕੰਮ ਤੋਂ ਪਹਿਲਾਂ ਅਸਥਾਈ ਵਾਟਰਪ੍ਰੂਫਿੰਗ।",
    },
    "/services/skylight-leak-flashing-repair": {
      title: "ਸਕਾਈਲਾਈਟ ਲੀਕ / ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ | Revolin Roofing",
      description: "ਲੀਕ ਕਰਦੇ ਸਕਾਈਲਾਈਟ ਅਤੇ ਆਲੇ-ਦੁਆਲੇ ਛੱਤ 'ਤੇ ਮੁਰੰਮਤ ਜਾਂ ਦੁਬਾਰਾ ਫਲੈਸ਼ਿੰਗ।",
    },
    "/services/chimney-flashing-repair": {
      title: "ਚਿਮਨੀ ਫਲੈਸ਼ਿੰਗ ਮੁਰੰਮਤ | Revolin Roofing",
      description:
        "ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਛੱਤਾਂ 'ਤੇ step flashing, counter-flashing ਅਤੇ ਚਿਮਨੀ-ਸੰਬੰਧਿਤ ਲੀਕ ਸੁਧਾਰ।",
    },
    "/services/gutter-replacement": {
      title: "ਗਟਰ ਬਦਲਣਾ | Revolin Roofing",
      description: "ਨਿਰਵਿਘਨ ਐਲੂਮੀਨੀਅਮ ਗਟਰ ਅਤੇ ਡਾਊਨਸਪਾਊਟ ਬਦਲੀ: ਈਵ ਡrerਨੇਜ ਭਰੋਸੇਮੰਦ।",
    },
    "/services/gutter-guard-installation": {
      title: "ਗਟਰ ਗਾਰਡ ਇੰਸਟਾਲੇਸ਼ਨ | Revolin Roofing",
      description: "ਰੁੱਖ-ਭਾਰੀ ਜਾਇਦਾਦਾਂ ਲਈ ਪੱਤੇ, ਮੌਸ ਅਤੇ ਮਲਬਾ ਬਲਾਕ ਘੱਟ।",
    },
    "/services/roof-ventilation-upgrade": {
      title: "ਛੱਤ ਹਵਾਦਾਰੀ ਅਪਗ੍ਰੇਡ | Revolin Roofing",
      description:
        "box vents, ridge vent, soffit intake ਅਤੇ ਐਟਿਕ ਏਅਰਫਲੋ ਸੁਧਾਰ: ਛੱਤ ਅਤੇ ਐਟਿਕ prformance ਲਈ।",
    },
    "/services/fascia-soffit-repair-replacement": {
      title: "fascia + soffit ਮੁਰੰਮਤ / ਬਦਲੀ | Revolin Roofing",
      description:
        "ਸੜੀ/ਖਰਾਬ fascia, soffit ਅਤੇ eave assemblies: ਗਟਰ/edge support। // NEEDS HUMAN REVIEW: fascia/soffit Gurmukhi loanwords",
    },
    "/services/cedar-shake-repair-restoration": {
      title: "cedar shake ਮੁਰੰਮਤ / ਬਹਾਲੀ | Revolin Roofing",
      description:
        "damaged cedar shakes replace + localized clean/restore premium wood roofs। // NEEDS HUMAN REVIEW: cedar shake terminology",
    },
    "/services/flat-low-slope-roof-repair": {
      title: "ਫਲੈਟ / ਘੱਟ-ਢਲਾਨ ਛੱਤ ਮੁਰੰਮਤ | Revolin Roofing",
      description: "flat/low-slope roofs: SBS, torch, TPO/EPDM patches, flashing, penetrations।",
    },
    "/services/metal-roof-repair-maintenance": {
      title: "metal ਛੱਤ ਮੁਰੰਮਤ / ਰੱਖ-ਰਖਾਅ | Revolin Roofing",
      description: "metal roof: fasteners, flashing, sealants, panels, penetrations।",
    },
    "/services/cedar-shake-roof-replacement": {
      title: "cedar shake ਛੱਤ ਬਦਲਣਾ | Revolin Roofing",
      description:
        "full premium cedar shake re-roof for homes keeping wood roof character। // NEEDS HUMAN REVIEW: cedar terminology",
    },
    "/services/metal-roof-replacement": {
      title: "ਧਾਤੂ ਛੱਤ ਬਦਲਣਾ | Revolin Roofing",
      description: "ਢੁਕਵੀਂ ਢਲਾਣ ਵਾਲੀ ਆਰਕੀਟੈਕਚਰ ਲਈ standing-seam ਜਾਂ ਹੋਰ ਪ੍ਰੀਮੀਅਮ ਧਾਤੂ ਰੀਰੂਫ।",
    },
    "/services/flat-roof-replacement-sbs-tpo-pvc": {
      title: "ਫਲੈਟ ਛੱਤ ਬਦਲਣਾ: SBS / TPO / PVC | Revolin Roofing",
      description:
        "SBS, TPO, PVC ਜਾਂ ਹੋਰ ਨਿਰਧਾਰਿਤ ਝਿੱਲੀ ਪ੍ਰਣਾਲੀਆਂ ਨਾਲ ਪੂਰੀ ਰਿਹਾਇਸ਼ੀ ਜਾਂ ਵਪਾਰਕ ਘੱਟ-ਢਲਾਨ ਰੀਰੂਫ।",
    },
  },
  "ko-kr": {
    "/": {
      title: "Revolin Roofing | 메트로 밴쿠버 전문 지붕 서비스",
      description:
        "메트로 밴쿠버 주택의 지붕 교체, 수리 및 지붕 시스템을 위한 세부 점검과 명확한 서면 작업 범위를 제공합니다.",
    },
    "/services": {
      title: "메트로 밴쿠버 지붕 서비스 | Revolin Roofing",
      description:
        "지붕 교체, 수리, 아스팔트 슁글, 금속, 저경사 지붕 및 점검·유지관리 서비스 분야를 확인하세요.",
    },
    "/about": {
      title: "Revolin Roofing 소개 | Revolin Group 계열사",
      description:
        "Revolin Roofing이 메트로 밴쿠버 주택의 지붕 점검, 서면 범위 작성 및 프로젝트 조율을 어떻게 진행하는지 알아보세요.",
    },
    "/before-after": {
      title: "시공 전후 지붕 갤러리 | Revolin Roofing",
      description:
        "메트로 밴쿠버의 Revolin Roofing 시공 전후 갤러리를 둘러보세요. 누수 보수, 아스팔트, 금속, 시더, 평지붕 변화를 로어메인랜드 주택 소유주를 위해 소개합니다.",
    },
    "/service-areas": {
      title: "메트로 밴쿠버 지붕 서비스 지역 | Revolin Roofing",
      description:
        "메트로 밴쿠버와 로어메인랜드의 확인된 서비스 지역을 확인하세요. 각 지역이 지점 사무실을 뜻하지는 않습니다.",
    },
    "/faq": {
      title: "지붕 관련 자주 묻는 질문 | Revolin Roofing",
      description:
        "지붕 점검, 수리, 교체, 시스템 선택, 작업 범위 및 메트로 밴쿠버 환경에 관한 답변을 확인하세요.",
    },
    "/contact": {
      title: "Revolin Roofing 문의 | 지붕 점검 요청",
      description: "확인된 서비스 지역의 지붕 점검, 수리 또는 교체에 관해 문의하세요.",
    },
    "/privacy": {
      title: "개인정보 처리방침 | Revolin Roofing",
      description:
        "Revolin Roofing이 웹 문의, 유입 정보 및 이 사이트를 통해 제출된 개인정보를 처리하는 방식을 확인하세요.",
    },
    "/terms": {
      title: "웹사이트 이용약관 | Revolin Roofing",
      description: "Revolin Roofing 웹사이트와 일반 지붕 정보 콘텐츠의 이용약관을 확인하세요.",
    },
    "/services/emergency-roof-leak-repair": {
      title: "긴급 지붕 누수 수리 메트로 밴쿠버 | Revolin Roofing",
      description:
        "메트로 밴쿠버 주택 누수 진단 및 국소 긴급 수리. 일정 허용 시 당일 방문. 원인 우선 평가와 명확한 다음 단계.",
    },
    "/services/flashing-roof-penetration-repair": {
      title: "플래싱·관통부 수리 밴쿠버 | Revolin Roofing",
      description: "굴뚝, 벽, 통풍구 및 pipe boot 플래싱 수리. 원인 중심 평가.",
    },
    "/services/moss-removal-roof-gutter": {
      title: "이끼 제거·홈통 청소 밴쿠버 | Revolin Roofing",
      description:
        "메트로 밴쿠버 주택 이끼 제거, 잔해 청소, 홈통 청소 및 시각 지붕 검사. 배수와 덮개 건강에 초점.",
    },
    "/services/asphalt-shingle-replacement": {
      title: "아스팔트 싱글 지붕 교체 밴쿠버 BC | Revolin Roofing",
      description:
        "메트로 밴쿠버 주택 건축용 아스팔트 싱글 교체. 철거, underlayment, 플래싱 통합 및 평가 후 서면 범위.",
    },
    "/services/roof-health-check-maintenance": {
      title: "지붕 건강 점검·유지보수 밴쿠버 | Revolin Roofing",
      description: "메트로 밴쿠버 지붕 건강 점검, 사진 및 유지보수 우선순위.",
    },
    "/services/shingle-spot-repair": {
      title: "싱글 spot 수리 메트로 밴쿠버 | Revolin Roofing",
      description: "주변 필드가 양호한 메트로 밴쿠버 주택 싱글 spot 수리.",
    },
    "/services/gutter-cleaning-downspout-flush": {
      title: "홈통 청소·downspout 밴쿠버 BC | Revolin Roofing",
      description: "메트로 밴쿠버 전문 홈통 청소 및 downspout flush.",
    },
    "/services/storm-tarping-emergency-dry-in": {
      title: "폭풍 방수포·긴급 dry-in 밴쿠버 | Revolin Roofing",
      description: "메트로 밴쿠버 폭풍·나무 손상 후 긴급 tarp·dry-in.",
    },
    "/services/skylight-leak-flashing-repair": {
      title: "skylight 누수·플래싱 수리 밴쿠버 | Revolin Roofing",
      description: "메트로 밴쿠버 skylight curb 플래싱 수리.",
    },
    "/services/chimney-flashing-repair": {
      title: "굴뚝 플래싱 수리 메트로 밴쿠버 | Revolin Roofing",
      description: "굴뚝 step·counter-flashing 수리.",
    },
    "/services/gutter-replacement": {
      title: "홈통 교체 메트로 밴쿠버 | Revolin Roofing",
      description: "seamless 알루미늄 홈통·downspout 교체.",
    },
    "/services/gutter-guard-installation": {
      title: "홈통 guard 설치 메트로 밴쿠버 | Revolin Roofing",
      description: "heavy 잔해 부지 홈통 guard 설치.",
    },
    "/services/roof-ventilation-upgrade": {
      title: "지붕 환기 업그레이드 메트로 밴쿠버 | Revolin Roofing",
      description: "soffit intake·exhaust 균형 환기 업그레이드.",
    },
    "/services/fascia-soffit-repair-replacement": {
      title: "fascia·soffit 수리 밴쿠버 | Revolin Roofing",
      description: "fascia·soffit 수리·교체.",
    },
    "/services/cedar-shake-repair-restoration": {
      title: "cedar shake 수리 메트로 밴쿠버 | Revolin Roofing",
      description: "cedar shake 국소 수리·복원.",
    },
    "/services/flat-low-slope-roof-repair": {
      title: "평지 지붕 수리 메트로 밴쿠버 | Revolin Roofing",
      description: "SBS, TPO, EPDM 저경사 막·플래싱 수리.",
    },
    "/services/metal-roof-repair-maintenance": {
      title: "금속 지붕 수리 메트로 밴쿠버 | Revolin Roofing",
      description: "패스너, 플래싱, closure, 관통부 금속 수리.",
    },
    "/services/cedar-shake-roof-replacement": {
      title: "cedar shake 지붕 교체 밴쿠버 BC | Revolin Roofing",
      description: "메트로 밴쿠버 cedar shake 전체 재지붕.",
    },
    "/services/metal-roof-replacement": {
      title: "금속 지붕 교체 메트로 밴쿠버 | Revolin Roofing",
      description:
        "메트로 밴쿠버 주택 standing seam 및 프리미엄 금속 지붕 교체. 기하학 중심 시스템 선택과 완전한 플래싱 통합.",
    },
    "/services/flat-roof-replacement-sbs-tpo-pvc": {
      title: "SBS·TPO·PVC 평지 지붕 교체 BC | Revolin Roofing",
      description:
        "메트로 밴쿠버 평지·저경사 지붕 SBS, TPO, PVC 또는 지정 막 시스템 전체 교체. 평가 후 범위.",
    },
  },
  "fa-ir": {
    "/": {
      title: "رولین روفینگ | سقف‌سازی حرفه‌ای در مترو ونکوور",
      description:
        "تعویض، تعمیر و سیستم‌های ممتاز سقف برای صاحبان خانه در مترو ونکوور، با ارزیابی دقیق و شرح کار مکتوب و شفاف.",
    },
    "/services": {
      title: "خدمات سقف در مترو ونکوور | رولین روفینگ",
      description:
        "با خدمات تعویض سقف، تعمیر، شینگل آسفالتی، سقف فلزی، سقف کم‌شیب و بازرسی و نگهداری آشنا شوید.",
    },
    "/about": {
      title: "درباره رولین روفینگ | شرکتی از گروه رولین",
      description:
        "ببینید رولین روفینگ چگونه ارزیابی سقف، شرح کار مکتوب و هماهنگی پروژه را برای خانه‌های مترو ونکوور انجام می‌دهد.",
    },
    "/before-after": {
      title: "گالری قبل و بعد سقف | رولین روفینگ",
      description:
        "گالری‌های قبل و بعد رولین روفینگ در مترو ونکوور را ببینید: از تعمیر نشتی تا سقف شینگل، فلزی، سدار و تخت برای صاحبان خانه در لوئر مینلند.",
    },
    "/service-areas": {
      title: "مناطق خدماتی سقف در مترو ونکوور | رولین روفینگ",
      description:
        "مناطق خدماتی تأییدشدهٔ رولین روفینگ در مترو ونکوور و لوئر مینلند را ببینید؛ این فهرست به معنای نشانی شعبه نیست.",
    },
    "/faq": {
      title: "پرسش‌های متداول سقف | رولین روفینگ",
      description:
        "پاسخ‌های روشن درباره ارزیابی، تعمیر، تعویض، انتخاب سیستم سقف، شرح کار و شرایط اقلیمی مترو ونکوور.",
    },
    "/contact": {
      title: "تماس با رولین روفینگ | درخواست ارزیابی سقف",
      description:
        "برای ارزیابی، تعمیر یا تعویض سقف در مناطق تحت پوشش با رولین روفینگ تماس بگیرید.",
    },
    "/privacy": {
      title: "سیاست حریم خصوصی | رولین روفینگ",
      description:
        "بخوانید رولین روفینگ چگونه با درخواست‌های وب‌سایت، اطلاعات ارجاع و داده‌های شخصی ارسال‌شده رفتار می‌کند.",
    },
    "/terms": {
      title: "شرایط استفاده از وب‌سایت | رولین روفینگ",
      description:
        "شرایط استفاده از وب‌سایت رولین روفینگ و محتوای آموزشی عمومی آن درباره سقف را بخوانید.",
    },
    "/services/emergency-roof-leak-repair": {
      title: "تعمیر فوری نشتی سقف در مترو ونکوور | رولین روفینگ",
      description:
        "تشخیص نشتی در اولویت، در صورت امکانِ برنامه‌ریزی، همان روز، همراه با تعمیر موضعی موقت یا دائمی وقتی آب به داخل خانه‌های مترو ونکوور نفوذ می‌کند.",
    },
    "/services/flashing-roof-penetration-repair": {
      title: "تعمیر فلاشینگ و نقاط عبور سقف ونکوور | رولین روفینگ",
      description:
        "تعمیر فلاشینگ دودکش، دیوار، دریچه‌ها و عایق دور لوله‌ها در سقف‌های مترو ونکوور: نقاطی که آب معمولاً از آنها نفوذ می‌کند.",
    },
    "/services/moss-removal-roof-gutter": {
      title: "خزه‌زدایی و لایروبی ناودان ونکوور | رولین روفینگ",
      description:
        "خزه‌زدایی، پاک‌سازی برگ و خاشاک، لایروبی ناودان و بازرسی چشمی سقف برای خانه‌های مترو ونکوور؛ نگهداری با تمرکز بر زهکشی و سلامت پوشش سقف.",
    },
    "/services/asphalt-shingle-replacement": {
      title: "تعویض شینگل آسفالتی ونکوور بریتیش کلمبیا | رولین روفینگ",
      description:
        "تعویض شینگل آسفالتی معماری برای خانه‌های مترو ونکوور: برچیدن کامل، زیرلایه، یکپارچه‌سازی فلاشینگ و شرح کار مکتوب پس از ارزیابی.",
    },
    "/services/roof-health-check-maintenance": {
      title: "چکاپ و نگهداری سقف ونکوور | رولین روفینگ",
      description:
        "بررسی وضعیت سقف همراه با عکس و اولویت‌های نگهداری برای صاحبان خانه در مترو ونکوور؛ مستندسازی شفاف پیش از تصمیم به تعمیر یا تعویض.",
    },
    "/services/shingle-spot-repair": {
      title: "تعمیر موضعی شینگل مترو ونکوور | رولین روفینگ",
      description:
        "تعمیر شینگل‌های افتاده، ترک‌خورده یا آسیب‌دیده از باد در خانه‌های مترو ونکوور، وقتی پوشش اطراف هنوز سالم و قابل استفاده است.",
    },
    "/services/gutter-cleaning-downspout-flush": {
      title: "لایروبی ناودان و شست‌وشوی لولهٔ ناودان ونکوور | رولین روفینگ",
      description:
        "لایروبی حرفه‌ای ناودان و شست‌وشوی لوله‌های ناودان برای خانه‌های مترو ونکوور؛ برقراری دوبارهٔ زهکشی لبهٔ بام و کاهش خطر سرریز.",
    },
    "/services/storm-tarping-emergency-dry-in": {
      title: "برزنت‌کشی اضطراری پس از طوفان ونکوور | رولین روفینگ",
      description:
        "پوشش اضطراری سقف و آب‌بندی موقت پس از آسیب طوفان یا سقوط درخت در مترو ونکوور؛ ایمن‌سازی بازشدگی تا زمان برنامه‌ریزی تعمیر دائمی.",
    },
    "/services/skylight-leak-flashing-repair": {
      title: "تعمیر نشتی و فلاشینگ نورگیر ونکوور | رولین روفینگ",
      description:
        "تشخیص نشتی نورگیر و تعمیر فلاشینگ دور آن برای خانه‌های مترو ونکوور؛ اصلاح اتصال سقف با نورگیر، نه فقط درزگیری شیشه.",
    },
    "/services/chimney-flashing-repair": {
      title: "تعمیر فلاشینگ دودکش مترو ونکوور | رولین روفینگ",
      description:
        "تعمیر فلاشینگ پله‌ای و کانترفلاشینگ دودکش در سقف‌های مترو ونکوور؛ رفع مسیر نشتی اطراف دودکش با اجرای درست جزئیات فلزی.",
    },
    "/services/gutter-replacement": {
      title: "تعویض ناودان مترو ونکوور | رولین روفینگ",
      description:
        "تعویض ناودان و لوله‌های ناودان آلومینیومی یکپارچه برای خانه‌های مترو ونکوور؛ با شیب‌بندی، خروجی‌ها و زهکشی درست لبهٔ بام.",
    },
    "/services/gutter-guard-installation": {
      title: "نصب محافظ ناودان مترو ونکوور | رولین روفینگ",
      description:
        "نصب محافظ ناودان برای خانه‌های پردرخت مترو ونکوور؛ کاهش دفعات گرفتگی در سیستم‌های ناودان سالم.",
    },
    "/services/roof-ventilation-upgrade": {
      title: "ارتقای تهویهٔ سقف ونکوور | رولین روفینگ",
      description:
        "ارتقای تهویهٔ سقف و زیرشیروانی برای خانه‌های مترو ونکوور؛ متعادل‌سازی ورودی هوای سوفیت و خروجی برای مدیریت رطوبت و گرما.",
    },
    "/services/fascia-soffit-repair-replacement": {
      title: "تعمیر فاسیا و سوفیت ونکوور | رولین روفینگ",
      description:
        "تعمیر یا تعویض فاسیا و سوفیت برای خانه‌های مترو ونکوور؛ احیای ساختار لبهٔ بام، ظاهر آن و بستن راه‌های نفوذ آب.",
    },
    "/services/cedar-shake-repair-restoration": {
      title: "تعمیر سقف چوبی سدار ونکوور | رولین روفینگ",
      description:
        "تعمیر و بازسازی موضعی سقف‌های چوبی سدار در مترو ونکوور؛ حفظ سقف سدار سالم با تعویض هدفمند تخته‌های آسیب‌دیده.",
    },
    "/services/flat-low-slope-roof-repair": {
      title: "تعمیر سقف تخت ونکوور | رولین روفینگ",
      description:
        "تعمیر سقف‌های تخت و کم‌شیب با غشاهای SBS، TPO، EPDM و مشابه در مترو ونکوور؛ وصله‌کاری درز، فلاشینگ و نقاط عبور در صورت امکان.",
    },
    "/services/metal-roof-repair-maintenance": {
      title: "تعمیر سقف فلزی ونکوور | رولین روفینگ",
      description:
        "تعمیر و نگهداری سقف فلزی برای خانه‌های مترو ونکوور؛ اصلاح بست‌ها، فلاشینگ، درزگیرها و نقاط عبور روی سیستم‌های فلزی موجود.",
    },
    "/services/cedar-shake-roof-replacement": {
      title: "تعویض سقف چوبی سدار ونکوور بریتیش کلمبیا | رولین روفینگ",
      description:
        "تعویض کامل سقف چوبی سدار برای خانه‌های مترو ونکوور؛ اجرای دوبارهٔ سقف چوبی ممتاز با آماده‌سازی زیرسازی و جزئیات درست.",
    },
    "/services/metal-roof-replacement": {
      title: "تعویض سقف فلزی مترو ونکوور | رولین روفینگ",
      description:
        "تعویض سقف فلزی ایستاده و سایر سقف‌های فلزی ممتاز برای خانه‌های مترو ونکوور؛ انتخاب سیستم بر اساس هندسهٔ سقف و یکپارچه‌سازی کامل فلاشینگ.",
    },
    "/services/flat-roof-replacement-sbs-tpo-pvc": {
      title: "تعویض سقف تخت SBS، TPO و PVC بریتیش کلمبیا | رولین روفینگ",
      description:
        "تعویض کامل سقف تخت و کم‌شیب در مترو ونکوور با SBS، TPO، PVC یا غشای دیگری که پس از ارزیابی مشخص می‌شود.",
    },
  },
  "ar-sa": {
    "/": {
      title: "رولين روفينغ | تسقيف احترافي في مترو فانكوفر",
      description:
        "استبدال الأسقف وإصلاحها وأنظمة تسقيف متميّزة لأصحاب المنازل في مترو فانكوفر، مع تقييم دقيق ونطاق عمل مكتوب وواضح.",
    },
    "/services": {
      title: "خدمات التسقيف في مترو فانكوفر | رولين روفينغ",
      description:
        "تعرّف على خدمات استبدال السقف والإصلاح وألواح الشينجل الأسفلتية والأسقف المعدنية ومنخفضة الميل والفحص والصيانة.",
    },
    "/about": {
      title: "عن رولين روفينغ | شركة تابعة لـ مجموعة رولين",
      description:
        "اكتشف كيف تدير رولين روفينغ تقييم الأسقف ونطاق العمل المكتوب وتنسيق المشاريع لمنازل مترو فانكوفر.",
    },
    "/before-after": {
      title: "معرض الأسقف قبل وبعد | رولين روفينغ",
      description:
        "استكشف معارض قبل وبعد من رولين روفينغ في مترو فانكوفر: من إصلاح التسرّب إلى أسقف الشينجل والمعدن وخشب الأرز والأسقف المسطحة لأصحاب المنازل في لوور مينلاند.",
    },
    "/service-areas": {
      title: "مناطق خدمة التسقيف في مترو فانكوفر | رولين روفينغ",
      description:
        "اطّلع على مناطق الخدمة المؤكدة لدى رولين روفينغ في مترو فانكوفر ولوور مينلاند؛ وهي ليست عناوين فروع.",
    },
    "/faq": {
      title: "أسئلة وأجوبة عن التسقيف | رولين روفينغ",
      description:
        "إجابات واضحة عن التقييم والإصلاح والاستبدال وأنظمة التسقيف ونطاق العمل وظروف مترو فانكوفر.",
    },
    "/contact": {
      title: "تواصل مع رولين روفينغ | اطلب تقييم السقف",
      description: "تواصل معنا بشأن تقييم السقف أو إصلاحه أو استبداله ضمن مناطق الخدمة المؤكدة.",
    },
    "/privacy": {
      title: "سياسة الخصوصية | رولين روفينغ",
      description:
        "تعرّف كيف تتعامل رولين روفينغ مع استفسارات الموقع ومعلومات الإسناد والبيانات الشخصية المقدَّمة عبر هذا الموقع.",
    },
    "/terms": {
      title: "شروط استخدام الموقع | رولين روفينغ",
      description: "اقرأ شروط استخدام موقع رولين روفينغ ومحتواه التثقيفي العام عن التسقيف.",
    },
    "/services/emergency-roof-leak-repair": {
      title: "إصلاح تسرّب السقف الطارئ | رولين روفينغ",
      description:
        "تشخيص التسرّب على وجه الأولوية، في اليوم نفسه متى سمح الجدول، مع إصلاح موضعي مؤقت أو دائم عندما يتسلل الماء إلى منازل مترو فانكوفر.",
    },
    "/services/flashing-roof-penetration-repair": {
      title: "إصلاح الفلاشينج ونقاط الاختراق فانكوفر | رولين روفينغ",
      description:
        "إصلاح فلاشينج المداخن والجدران والفتحات وعوازل الأنابيب لأسقف مترو فانكوفر: وهي المواضع التي يتسلل منها الماء عادةً.",
    },
    "/services/moss-removal-roof-gutter": {
      title: "إزالة الطحالب وتنظيف المزاريب فانكوفر | رولين روفينغ",
      description:
        "إزالة الطحالب وتنظيف المخلفات والمزاريب وفحص بصري للسقف لمنازل مترو فانكوفر؛ صيانة تركّز على التصريف وسلامة الغطاء.",
    },
    "/services/asphalt-shingle-replacement": {
      title: "استبدال ألواح الشينجل الأسفلتية | رولين روفينغ",
      description:
        "استبدال ألواح الشينجل الأسفلتية المعمارية لمنازل مترو فانكوفر: إزالة كاملة وطبقة تحتية ودمج للفلاشينج ونطاق عمل مكتوب بعد التقييم.",
    },
    "/services/roof-health-check-maintenance": {
      title: "فحص صحة السقف والصيانة فانكوفر | رولين روفينغ",
      description:
        "فحص لحالة السقف مع صور وأولويات صيانة لأصحاب المنازل في مترو فانكوفر؛ توثيق واضح قبل قرار الإصلاح أو الاستبدال.",
    },
    "/services/shingle-spot-repair": {
      title: "إصلاح موضعي لألواح الشينجل مترو فانكوفر | رولين روفينغ",
      description:
        "إصلاح ألواح شينجل مفقودة أو متشققة أو متضررة من الرياح في مترو فانكوفر عندما يظل الغطاء المحيط صالحاً للخدمة.",
    },
    "/services/gutter-cleaning-downspout-flush": {
      title: "تنظيف المزاريب وغسل أنابيب التصريف فانكوفر | رولين روفينغ",
      description:
        "تنظيف احترافي للمزاريب وغسل أنابيب التصريف لمنازل مترو فانكوفر؛ استعادة تصريف حافة السطح وتقليل خطر الفيضان.",
    },
    "/services/storm-tarping-emergency-dry-in": {
      title: "تغطية طارئة بعد العواصف فانكوفر | رولين روفينغ",
      description:
        "تغطية طارئة للسقف وعزل مؤقت بعد أضرار العواصف أو سقوط الأشجار في مترو فانكوفر؛ تأمين الفتحات إلى حين التخطيط للإصلاح الدائم.",
    },
    "/services/skylight-leak-flashing-repair": {
      title: "إصلاح تسرّب المناور والفلاشينج فانكوفر | رولين روفينغ",
      description:
        "تشخيص تسرّب المناور وإصلاح الفلاشينج حولها لمنازل مترو فانكوفر؛ معالجة التقاء السقف بالمنور لا أختام الزجاج فقط.",
    },
    "/services/chimney-flashing-repair": {
      title: "إصلاح فلاشينج المدخنة مترو فانكوفر | رولين روفينغ",
      description:
        "إصلاح الفلاشينج المتدرّج والمضاد حول المداخن في مترو فانكوفر؛ معالجة مسارات التسرّب بتفاصيل معدنية صحيحة.",
    },
    "/services/gutter-replacement": {
      title: "استبدال المزاريب مترو فانكوفر | رولين روفينغ",
      description:
        "استبدال مزاريب وأنابيب تصريف من الألومنيوم غير الملحوم لمنازل مترو فانكوفر، مع ميل ومخارج صحيحة وتصريف موثوق لحافة السطح.",
    },
    "/services/gutter-guard-installation": {
      title: "تركيب واقيات المزاريب مترو فانكوفر | رولين روفينغ",
      description:
        "تركيب واقيات المزاريب لمنازل مترو فانكوفر المحاطة بالأشجار؛ تقليل تكرار الانسداد في أنظمة مزاريب سليمة.",
    },
    "/services/roof-ventilation-upgrade": {
      title: "ترقية تهوية السقف مترو فانكوفر | رولين روفينغ",
      description:
        "ترقية تهوية السقف والعلّية لمنازل مترو فانكوفر؛ موازنة مدخل الهواء عند السوفيت مع العادم لإدارة الرطوبة والحرارة.",
    },
    "/services/fascia-soffit-repair-replacement": {
      title: "إصلاح الفاشيا والسوفيت مترو فانكوفر | رولين روفينغ",
      description:
        "إصلاح أو استبدال الفاشيا والسوفيت لمنازل مترو فانكوفر؛ استعادة بنية حافة السطح ومظهرها وسد مسارات تسلل الماء.",
    },
    "/services/cedar-shake-repair-restoration": {
      title: "إصلاح أسقف خشب الأرز مترو فانكوفر | رولين روفينغ",
      description:
        "إصلاح واستعادة موضعية لأسقف خشب الأرز في مترو فانكوفر؛ الحفاظ على السقف الصالح باستبدال الألواح المتضررة فقط.",
    },
    "/services/flat-low-slope-roof-repair": {
      title: "إصلاح السقف المسطح مترو فانكوفر | رولين روفينغ",
      description:
        "إصلاح الأسقف المسطحة ومنخفضة الميل بأغشية SBS وTPO وEPDM وما شابه في مترو فانكوفر؛ ترقيع الدرزات والفلاشينج ونقاط الاختراق متى أمكن.",
    },
    "/services/metal-roof-repair-maintenance": {
      title: "إصلاح السقف المعدني مترو فانكوفر | رولين روفينغ",
      description:
        "إصلاح وصيانة الأسقف المعدنية لمنازل مترو فانكوفر؛ معالجة المثبّتات والفلاشينج ومواد الإغلاق ونقاط الاختراق في الأنظمة القائمة.",
    },
    "/services/cedar-shake-roof-replacement": {
      title: "استبدال سقف خشب الأرز فانكوفر | رولين روفينغ",
      description:
        "استبدال كامل لأسقف خشب الأرز لمنازل مترو فانكوفر؛ إعادة تسقيف خشبية متميّزة مع تجهيز القاعدة وتنفيذ التفاصيل بدقة.",
    },
    "/services/metal-roof-replacement": {
      title: "استبدال السقف المعدني مترو فانكوفر | رولين روفينغ",
      description:
        "استبدال الأسقف المعدنية بدرزات قائمة وغيرها من الأنظمة المتميّزة لمنازل مترو فانكوفر؛ اختيار النظام وفق هندسة السقف مع دمج كامل للفلاشينج.",
    },
    "/services/flat-roof-replacement-sbs-tpo-pvc": {
      title: "استبدال السقف المسطح SBS و TPO و PVC كولومبيا البريطانية | رولين روفينغ",
      description:
        "استبدال كامل للأسقف المسطحة ومنخفضة الميل في مترو فانكوفر باستخدام SBS أو TPO أو PVC أو غشاء آخر يُحدَّد بعد التقييم.",
    },
  },
};

/**
 * Metadata for the province-wide expansion hubs. These pages deliberately
 * distinguish Lower Mainland emergency response from scheduled BC projects.
 */
const expansionMeta: Record<TranslatedLocale, Record<string, PageMetaCopy>> = {
  "zh-cn": {
    "/emergency-roofing": {
      title: "低陆平原紧急屋顶服务｜Revolin Roofing",
      description:
        "为低陆平原的屋顶漏水和风暴损坏提供紧急协助，具体安排取决于施工团队档期和现场安全条件。",
    },
    "/commercial-roofing": {
      title: "卑诗省商业屋顶服务｜Revolin Roofing",
      description:
        "为卑诗省符合条件的计划项目提供商业屋顶评估、维修、更换和维护，服务范围取决于工程规模与调度安排。",
    },
    "/strata-roofing": {
      title: "卑诗省共管物业屋顶服务｜Revolin Roofing",
      description: "为卑诗省共管社区和物业管理方提供屋顶评估、维修、更换规划与预防性维护。",
    },
    "/residential-roofing": {
      title: "卑诗省住宅屋顶服务｜Revolin Roofing",
      description: "在低陆平原提供住宅屋顶维修与更换，并承接卑诗省各地符合条件的计划性屋顶项目。",
    },
    "/roof-systems": {
      title: "卑诗省建筑屋顶系统指南｜Revolin Roofing",
      description:
        "比较沥青瓦、雪松木瓦、金属与低坡膜材系统，并根据建筑、暴露条件、排水和项目范围选择方案。",
    },
    "/roof-estimate": {
      title: "申请卑诗省屋顶估价｜Revolin Roofing",
      description:
        "提交物业、屋顶、时间与工程信息，让 Revolin Roofing 审核项目范围并准备初步屋顶估价。",
    },
    "/service-areas/british-columbia": {
      title: "卑诗省屋顶服务覆盖范围｜Revolin Roofing",
      description:
        "紧急屋顶服务覆盖低陆平原；符合条件的住宅、商业与共管物业计划项目可服务卑诗省各地。",
    },
  },
  "zh-tw": {
    "/emergency-roofing": {
      title: "低陸平原緊急屋頂服務｜Revolin Roofing",
      description:
        "為低陸平原的屋頂漏水與風暴損壞提供緊急協助，實際安排取決於施工團隊檔期與現場安全條件。",
    },
    "/commercial-roofing": {
      title: "卑詩省商業屋頂服務｜Revolin Roofing",
      description:
        "為卑詩省符合條件的計畫專案提供商業屋頂評估、維修、更換與維護，服務範圍取決於工程規模及調度安排。",
    },
    "/strata-roofing": {
      title: "卑詩省共管物業屋頂服務｜Revolin Roofing",
      description: "為卑詩省共管社區及物業管理方提供屋頂評估、維修、更換規劃與預防性維護。",
    },
    "/residential-roofing": {
      title: "卑詩省住宅屋頂服務｜Revolin Roofing",
      description: "在低陸平原提供住宅屋頂維修與更換，並承接卑詩省各地符合條件的計畫性屋頂專案。",
    },
    "/roof-systems": {
      title: "卑詩省建築屋頂系統指南｜Revolin Roofing",
      description:
        "比較瀝青瓦、雪松木瓦、金屬與低坡膜材系統，並依建築、暴露條件、排水及專案範圍選擇方案。",
    },
    "/roof-estimate": {
      title: "申請卑詩省屋頂估價｜Revolin Roofing",
      description:
        "提交物業、屋頂、時間與工程資訊，讓 Revolin Roofing 審核專案範圍並準備初步屋頂估價。",
    },
    "/service-areas/british-columbia": {
      title: "卑詩省屋頂服務覆蓋範圍｜Revolin Roofing",
      description:
        "緊急屋頂服務覆蓋低陸平原；符合條件的住宅、商業與共管物業計畫專案可服務卑詩省各地。",
    },
  },
  "pa-in": {
    "/emergency-roofing": {
      title: "ਲੋਅਰ ਮੇਨਲੈਂਡ ਐਮਰਜੈਂਸੀ ਰੂਫਿੰਗ | Revolin Roofing",
      description:
        "ਲੋਅਰ ਮੇਨਲੈਂਡ ਵਿੱਚ ਚੱਲ ਰਹੀ ਛੱਤ ਲੀਕ ਅਤੇ ਤੂਫ਼ਾਨੀ ਨੁਕਸਾਨ ਲਈ ਤੁਰੰਤ ਮਦਦ, ਟੀਮ ਦੀ ਉਪਲਬਧਤਾ ਅਤੇ ਸੁਰੱਖਿਅਤ ਸਾਈਟ ਪਹੁੰਚ ਦੇ ਅਧੀਨ।",
    },
    "/commercial-roofing": {
      title: "ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਕਮਰਸ਼ੀਅਲ ਰੂਫਿੰਗ | Revolin Roofing",
      description:
        "ਪ੍ਰੋਜੈਕਟ ਦੇ ਦਾਇਰੇ ਅਤੇ ਮੋਬਿਲਾਈਜ਼ੇਸ਼ਨ ਦੇ ਅਧੀਨ ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਵਿੱਚ ਯੋਜਨਾਬੱਧ ਵਪਾਰਕ ਛੱਤ ਜਾਂਚ, ਮੁਰੰਮਤ, ਬਦਲੀ ਅਤੇ ਸੰਭਾਲ।",
    },
    "/strata-roofing": {
      title: "ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਸਟ੍ਰਾਟਾ ਰੂਫਿੰਗ | Revolin Roofing",
      description:
        "ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਦੀਆਂ ਸਟ੍ਰਾਟਾ ਕਮਿਊਨਿਟੀਆਂ ਅਤੇ ਪ੍ਰਾਪਰਟੀ ਮੈਨੇਜਰਾਂ ਲਈ ਛੱਤ ਜਾਂਚ, ਮੁਰੰਮਤ, ਬਦਲੀ ਯੋਜਨਾ ਅਤੇ ਰੋਕਥਾਮੀ ਸੰਭਾਲ।",
    },
    "/residential-roofing": {
      title: "ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਰਿਹਾਇਸ਼ੀ ਰੂਫਿੰਗ | Revolin Roofing",
      description:
        "ਲੋਅਰ ਮੇਨਲੈਂਡ ਵਿੱਚ ਘਰੇਲੂ ਛੱਤ ਮੁਰੰਮਤ ਅਤੇ ਬਦਲੀ, ਨਾਲ ਹੀ ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਭਰ ਵਿੱਚ ਯੋਗ ਯੋਜਨਾਬੱਧ ਛੱਤ ਪ੍ਰੋਜੈਕਟ।",
    },
    "/roof-systems": {
      title: "ਬੀਸੀ ਇਮਾਰਤਾਂ ਲਈ ਛੱਤ ਪ੍ਰਣਾਲੀਆਂ | Revolin Roofing",
      description:
        "ਇਮਾਰਤ, ਮੌਸਮੀ ਪ੍ਰਭਾਵ, ਡਰੇਨੇਜ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਦੇ ਦਾਇਰੇ ਅਨੁਸਾਰ ਐਸਫਾਲਟ ਸ਼ਿੰਗਲ, ਸੀਡਰ, ਮੈਟਲ ਅਤੇ ਘੱਟ ਢਲਾਣ ਝਿੱਲੀ ਪ੍ਰਣਾਲੀਆਂ ਦੀ ਤੁਲਨਾ ਕਰੋ।",
    },
    "/roof-estimate": {
      title: "ਬੀਸੀ ਵਿੱਚ ਛੱਤ ਦਾ ਅਨੁਮਾਨ ਮੰਗੋ | Revolin Roofing",
      description:
        "ਆਪਣੀ ਪ੍ਰਾਪਰਟੀ, ਛੱਤ, ਸਮਾਂ ਅਤੇ ਪ੍ਰੋਜੈਕਟ ਦੇ ਵੇਰਵੇ ਭੇਜੋ ਤਾਂ ਜੋ Revolin Roofing ਦਾਇਰਾ ਵੇਖ ਕੇ ਮੁੱਢਲਾ ਅਨੁਮਾਨ ਤਿਆਰ ਕਰ ਸਕੇ।",
    },
    "/service-areas/british-columbia": {
      title: "ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਭਰ ਵਿੱਚ ਰੂਫਿੰਗ | Revolin Roofing",
      description:
        "ਐਮਰਜੈਂਸੀ ਰੂਫਿੰਗ ਲੋਅਰ ਮੇਨਲੈਂਡ ਲਈ ਹੈ; ਯੋਗ ਯੋਜਨਾਬੱਧ ਰਿਹਾਇਸ਼ੀ, ਵਪਾਰਕ ਅਤੇ ਸਟ੍ਰਾਟਾ ਪ੍ਰੋਜੈਕਟ ਬ੍ਰਿਟਿਸ਼ ਕੋਲੰਬੀਆ ਭਰ ਵਿੱਚ ਉਪਲਬਧ ਹਨ।",
    },
  },
  "ko-kr": {
    "/emergency-roofing": {
      title: "로어 메인랜드 긴급 지붕 서비스 | Revolin Roofing",
      description:
        "로어 메인랜드의 진행 중인 누수와 폭풍 피해에 긴급 대응합니다. 작업팀 일정과 안전한 현장 접근 가능 여부에 따라 배정됩니다.",
    },
    "/commercial-roofing": {
      title: "브리티시컬럼비아 상업용 지붕 | Revolin Roofing",
      description:
        "공사 범위와 출동 여건에 따라 브리티시컬럼비아 전역의 계획된 상업용 지붕 점검, 수리, 교체 및 유지관리를 제공합니다.",
    },
    "/strata-roofing": {
      title: "브리티시컬럼비아 공동주택 지붕 | Revolin Roofing",
      description:
        "브리티시컬럼비아의 공동주택 단지와 부동산 관리자를 위한 지붕 점검, 수리, 교체 계획 및 예방 관리를 제공합니다.",
    },
    "/residential-roofing": {
      title: "브리티시컬럼비아 주택 지붕 | Revolin Roofing",
      description:
        "로어 메인랜드의 주택 지붕 수리와 교체, 그리고 브리티시컬럼비아 전역의 조건에 맞는 계획 공사를 제공합니다.",
    },
    "/roof-systems": {
      title: "BC 건물을 위한 지붕 시스템 안내 | Revolin Roofing",
      description:
        "건물 용도, 노출 환경, 배수 및 공사 범위에 따라 아스팔트 슁글, 시더, 금속 및 저경사 멤브레인 시스템을 비교합니다.",
    },
    "/roof-estimate": {
      title: "BC 지붕 견적 요청 | Revolin Roofing",
      description:
        "건물, 지붕, 희망 일정 및 공사 정보를 보내 주시면 Revolin Roofing이 범위를 검토하고 예비 견적을 준비합니다.",
    },
    "/service-areas/british-columbia": {
      title: "브리티시컬럼비아 전역 지붕 서비스 | Revolin Roofing",
      description:
        "긴급 지붕 서비스는 로어 메인랜드를 대상으로 하며, 조건에 맞는 주택·상업·공동주택 계획 공사는 브리티시컬럼비아 전역에서 가능합니다.",
    },
  },
  "fa-ir": {
    "/emergency-roofing": {
      title: "خدمات اضطراری سقف در لوئر مین‌لند | رولین روفینگ",
      description:
        "رسیدگی فوری به نشتی فعال سقف و خسارت طوفان در لوئر مین‌لند؛ پذیرش کار به ظرفیت تیم و امکان دسترسی ایمن به محل بستگی دارد.",
    },
    "/commercial-roofing": {
      title: "خدمات سقف تجاری در بریتیش کلمبیا | رولین روفینگ",
      description:
        "ارزیابی، تعمیر، تعویض و نگهداری برنامه‌ریزی‌شدهٔ سقف ساختمان‌های تجاری در بریتیش کلمبیا؛ با توجه به ابعاد پروژه و شرایط اعزام نیرو.",
    },
    "/strata-roofing": {
      title: "خدمات سقف مجتمع‌های استراتا در بریتیش کلمبیا | رولین روفینگ",
      description:
        "ارزیابی، تعمیر، برنامه‌ریزی تعویض و نگهداری پیشگیرانهٔ سقف برای مجتمع‌های استراتا و مدیران املاک در بریتیش کلمبیا.",
    },
    "/residential-roofing": {
      title: "خدمات سقف مسکونی در بریتیش کلمبیا | رولین روفینگ",
      description:
        "تعمیر و تعویض سقف خانه‌ها در لوئر مین‌لند و اجرای پروژه‌های برنامه‌ریزی‌شدهٔ واجد شرایط در سراسر بریتیش کلمبیا.",
    },
    "/roof-systems": {
      title: "راهنمای سیستم‌های سقف در بریتیش کلمبیا | رولین روفینگ",
      description:
        "مقایسهٔ شینگل آسفالتی، سدار، فلز و غشاهای کم‌شیب بر اساس نوع ساختمان، شرایط محیطی، زهکشی و ابعاد پروژه.",
    },
    "/roof-estimate": {
      title: "درخواست برآورد هزینهٔ سقف در بریتیش کلمبیا | رولین روفینگ",
      description:
        "مشخصات ملک، سقف، زمان‌بندی و پروژه را بفرستید تا رولین روفینگ شرح کار را بررسی و برآورد اولیه را آماده کند.",
    },
    "/service-areas/british-columbia": {
      title: "خدمات سقف در سراسر بریتیش کلمبیا | رولین روفینگ",
      description:
        "خدمات اضطراری سقف ویژهٔ لوئر مین‌لند است؛ پروژه‌های برنامه‌ریزی‌شدهٔ واجد شرایط برای ساختمان‌های مسکونی، تجاری و استراتا در سراسر بریتیش کلمبیا انجام می‌شود.",
    },
  },
  "ar-sa": {
    "/emergency-roofing": {
      title: "خدمات الأسقف الطارئة في لوور مينلاند | رولين روفينغ",
      description:
        "مساعدة عاجلة لتسرّبات السقف النشطة وأضرار العواصف في لوور مينلاند، وفق توافر الفريق وإمكانية الوصول الآمن إلى الموقع.",
    },
    "/commercial-roofing": {
      title: "خدمات الأسقف التجارية في كولومبيا البريطانية | رولين روفينغ",
      description:
        "تقييم وإصلاح واستبدال وصيانة مخططة للأسقف التجارية في كولومبيا البريطانية، وفق نطاق المشروع ومتطلبات الانتقال إلى الموقع.",
    },
    "/strata-roofing": {
      title: "أسقف المجمعات السكنية في كولومبيا البريطانية | رولين روفينغ",
      description:
        "تقييم الأسقف وإصلاحها والتخطيط لاستبدالها وصيانتها الوقائية للمجمعات السكنية ومديري العقارات في كولومبيا البريطانية.",
    },
    "/residential-roofing": {
      title: "خدمات الأسقف السكنية في كولومبيا البريطانية | رولين روفينغ",
      description:
        "إصلاح واستبدال أسقف المنازل في لوور مينلاند، وتنفيذ المشاريع المجدولة المؤهلة في أنحاء كولومبيا البريطانية.",
    },
    "/roof-systems": {
      title: "دليل أنظمة الأسقف في كولومبيا البريطانية | رولين روفينغ",
      description:
        "مقارنة ألواح الشينجل الأسفلتية وخشب الأرز والمعدن والأغشية منخفضة الميل وفق المبنى والتعرّض والتصريف ونطاق المشروع.",
    },
    "/roof-estimate": {
      title: "اطلب تقديراً لتكلفة السقف في كولومبيا البريطانية | رولين روفينغ",
      description:
        "أرسل تفاصيل العقار والسقف والجدول الزمني والمشروع لتراجع رولين روفينغ نطاق العمل وتُعد تقديراً أولياً.",
    },
    "/service-areas/british-columbia": {
      title: "خدمات الأسقف في أنحاء كولومبيا البريطانية | رولين روفينغ",
      description:
        "خدمات الأسقف الطارئة مخصصة للوور مينلاند؛ أما المشاريع السكنية والتجارية ومشاريع المجمعات السكنية المجدولة والمؤهلة فتتوفر في أنحاء كولومبيا البريطانية.",
    },
  },
};

const serviceNames: Record<TranslatedLocale, Record<string, string>> = {
  "zh-cn": {
    "roof-replacement": "屋顶更换",
    "roof-repair": "屋顶维修与漏水诊断",
    "asphalt-shingle-roofing": "建筑沥青瓦屋顶",
    "metal-roofing": "立边咬合金属屋顶",
    "flat-roofing": "平屋顶与低坡屋顶",
    "roof-inspection-maintenance": "屋顶检查与预防性维护",
  },
  "zh-tw": {
    "roof-replacement": "屋頂更換",
    "roof-repair": "屋頂維修與漏水診斷",
    "asphalt-shingle-roofing": "建築瀝青瓦屋頂",
    "metal-roofing": "立邊咬合金屬屋頂",
    "flat-roofing": "平屋頂與低坡屋頂",
    "roof-inspection-maintenance": "屋頂檢查與預防性維護",
  },
  "pa-in": {
    "roof-replacement": "ਛੱਤ ਬਦਲਣਾ",
    "roof-repair": "ਛੱਤ ਮੁਰੰਮਤ ਅਤੇ ਲੀਕ ਦੀ ਜਾਂਚ",
    "asphalt-shingle-roofing": "ਆਰਕੀਟੈਕਚਰਲ ਐਸਫਾਲਟ ਸ਼ਿੰਗਲ ਛੱਤ",
    "metal-roofing": "ਸਟੈਂਡਿੰਗ-ਸੀਮ ਮੈਟਲ ਛੱਤ",
    "flat-roofing": "ਫਲੈਟ ਅਤੇ ਘੱਟ ਢਲਾਣ ਵਾਲੀ ਛੱਤ",
    "roof-inspection-maintenance": "ਛੱਤ ਜਾਂਚ ਅਤੇ ਰੋਕਥਾਮੀ ਸੰਭਾਲ",
  },
  "ko-kr": {
    "roof-replacement": "지붕 교체",
    "roof-repair": "지붕 수리 및 누수 진단",
    "asphalt-shingle-roofing": "건축용 아스팔트 슁글 지붕",
    "metal-roofing": "스탠딩 심 금속 지붕",
    "flat-roofing": "평지붕 및 저경사 지붕",
    "roof-inspection-maintenance": "지붕 점검 및 예방 관리",
  },
  "fa-ir": {
    "roof-replacement": "تعویض کامل سقف",
    "roof-repair": "تعمیر سقف و تشخیص نشتی",
    "asphalt-shingle-roofing": "سقف شینگل آسفالتی معماری",
    "metal-roofing": "سقف فلزی ایستاده",
    "flat-roofing": "سقف تخت و کم‌شیب",
    "roof-inspection-maintenance": "بازرسی و نگهداری پیشگیرانهٔ سقف",
  },
  "ar-sa": {
    "roof-replacement": "استبدال السقف بالكامل",
    "roof-repair": "إصلاح السقف وتشخيص التسرّب",
    "asphalt-shingle-roofing": "سقف ألواح الشينجل الأسفلتية المعمارية",
    "metal-roofing": "سقف معدني بدرزات قائمة",
    "flat-roofing": "سقف مسطح ومنخفض الميل",
    "roof-inspection-maintenance": "فحص السقف والصيانة الوقائية",
  },
};

const serviceDescriptions: Record<TranslatedLocale, Record<string, string>> = {
  "zh-cn": {
    "roof-replacement": "从现状评估开始，根据住宅、屋顶结构和大温哥华气候规划完整的屋顶更换方案。",
    "roof-repair": "针对漏水、局部失效、穿透部位、泛水问题及可维修损坏进行重点诊断和维修规划。",
    "asphalt-shingle-roofing": "适用于合适陡坡住宅屋顶的实用型建筑沥青瓦系统，并兼顾外观选择。",
    "metal-roofing": "根据建筑风格、屋顶结构和性能需求评估立边咬合金属屋顶是否适用。",
    "flat-roofing": "为平屋顶和低坡屋顶规划膜系统，重点关注排水坡度、连续性和交接细节。",
    "roof-inspection-maintenance":
      "记录屋顶系统及薄弱细节，并提出维护、观察或进一步工作的实际优先顺序。",
  },
  "zh-tw": {
    "roof-replacement": "從現況評估開始，依據住宅、屋頂結構和大溫哥華氣候規劃完整的屋頂更換方案。",
    "roof-repair": "針對漏水、局部失效、穿透部位、泛水問題及可維修損壞進行重點診斷和維修規劃。",
    "asphalt-shingle-roofing": "適用於合適陡坡住宅屋頂的實用型建築瀝青瓦系統，並兼顧外觀選擇。",
    "metal-roofing": "依據建築風格、屋頂結構和性能需求評估立邊咬合金屬屋頂是否適用。",
    "flat-roofing": "為平屋頂和低坡屋頂規劃膜系統，重點關注排水坡度、連續性和交接細節。",
    "roof-inspection-maintenance":
      "記錄屋頂系統及薄弱細節，並提出維護、觀察或進一步工作的實際優先順序。",
  },
  "pa-in": {
    "roof-replacement":
      "ਘਰ, ਛੱਤ ਦੀ ਬਣਤਰ ਅਤੇ ਮੈਟਰੋ ਵੈਨਕੂਵਰ ਦੇ ਮੌਸਮ ਅਨੁਸਾਰ ਹਾਲਤ ਦੀ ਜਾਂਚ ਤੋਂ ਪੂਰੀ ਛੱਤ ਬਦਲੀ ਤੱਕ ਦੀ ਯੋਜਨਾ।",
    "roof-repair":
      "ਲੀਕ, ਸੀਮਤ ਨੁਕਸ, ਪੈਨਿਟ੍ਰੇਸ਼ਨ, ਫਲੈਸ਼ਿੰਗ ਅਤੇ ਮੁਰੰਮਤਯੋਗ ਨੁਕਸਾਨ ਲਈ ਕੇਂਦਰਿਤ ਜਾਂਚ ਅਤੇ ਮੁਰੰਮਤ ਯੋਜਨਾ।",
    "asphalt-shingle-roofing":
      "ਉਚਿਤ ਢਲਾਣ ਵਾਲੀਆਂ ਰਿਹਾਇਸ਼ੀ ਛੱਤਾਂ ਲਈ ਵਿਹਾਰਕ ਅਤੇ ਡਿਜ਼ਾਈਨ-ਸਚੇਤ ਐਸਫਾਲਟ ਸ਼ਿੰਗਲ ਸਿਸਟਮ।",
    "metal-roofing":
      "ਇਮਾਰਤ ਦੀ ਬਣਤਰ, ਛੱਤ ਦੀ ਜਿਓਮੈਟਰੀ ਅਤੇ ਕਾਰਗੁਜ਼ਾਰੀ ਦੀਆਂ ਤਰਜੀਹਾਂ ਅਨੁਸਾਰ ਸਟੈਂਡਿੰਗ-ਸੀਮ ਮੈਟਲ ਦਾ ਮੁਲਾਂਕਣ।",
    "flat-roofing":
      "ਫਲੈਟ ਅਤੇ ਘੱਟ ਢਲਾਣ ਵਾਲੇ ਹਿੱਸਿਆਂ ਲਈ ਝਿੱਲੀ ਦੀ ਲਗਾਤਾਰਤਾ, ਡਰੇਨੇਜ ਅਤੇ ਜੋੜਾਂ ਉੱਤੇ ਕੇਂਦਰਿਤ ਯੋਜਨਾ।",
    "roof-inspection-maintenance":
      "ਛੱਤ ਅਤੇ ਕਮਜ਼ੋਰ ਵੇਰਵਿਆਂ ਦੀ ਦਰਜ ਜਾਂਚ, ਨਾਲ ਹੀ ਸੰਭਾਲ, ਨਿਗਰਾਨੀ ਜਾਂ ਅਗਲੇ ਕੰਮ ਦੀਆਂ ਤਰਜੀਹਾਂ।",
  },
  "ko-kr": {
    "roof-replacement":
      "주택, 지붕 구조 및 메트로 밴쿠버 기후에 맞춰 상태 점검부터 전체 지붕 교체까지 계획합니다.",
    "roof-repair":
      "누수, 국부 결함, 관통부, 후레싱 및 수리 가능한 손상을 중심으로 진단하고 수리 범위를 계획합니다.",
    "asphalt-shingle-roofing":
      "적합한 급경사 주택 지붕을 위한 실용적이고 디자인을 고려한 건축용 아스팔트 슁글 시스템입니다.",
    "metal-roofing":
      "건축, 지붕 형상 및 성능 우선순위에 따라 스탠딩 심 금속 지붕의 적합성을 검토합니다.",
    "flat-roofing":
      "평지붕과 저경사 구간의 멤브레인 연속성, 배수 경사 및 전이부를 중심으로 계획합니다.",
    "roof-inspection-maintenance":
      "지붕 시스템과 취약한 세부를 기록하고 유지관리, 관찰 또는 추가 작업의 우선순위를 제시합니다.",
  },
  "fa-ir": {
    "roof-replacement":
      "از ارزیابی وضعیت تا برنامه‌ریزی تعویض کامل سقف، متناسب با خانه، هندسهٔ سقف و اقلیم مترو ونکوور.",
    "roof-repair":
      "تشخیص و برنامه‌ریزی تعمیر با تمرکز بر نشتی، خرابی‌های موضعی، نقاط عبور تأسیسات، فلاشینگ و آسیب‌های قابل‌تعمیر.",
    "asphalt-shingle-roofing":
      "سیستم شینگل آسفالتی معماری، کاربردی و خوش‌ظاهر برای سقف‌های مسکونی با شیب مناسب.",
    "metal-roofing":
      "بررسی مناسب بودن سقف فلزی ایستاده بر اساس معماری، هندسهٔ سقف و اولویت‌های عملکردی.",
    "flat-roofing":
      "برنامه‌ریزی سیستم غشایی برای سقف تخت و کم‌شیب با تمرکز بر شیب زهکشی، پیوستگی و جزئیات نقاط انتقال.",
    "roof-inspection-maintenance":
      "ثبت وضعیت سیستم سقف و جزئیات آسیب‌پذیر، همراه با اولویت‌بندی نگهداری، پایش یا اقدام بعدی.",
  },
  "ar-sa": {
    "roof-replacement":
      "من تقييم الحالة إلى تخطيط استبدال كامل للسقف بما يناسب المنزل وهندسة السقف ومناخ مترو فانكوفر.",
    "roof-repair":
      "تشخيص وتخطيط إصلاح يركّز على التسرّب والأعطال الموضعية ونقاط الاختراق والفلاشينج والتلف القابل للإصلاح.",
    "asphalt-shingle-roofing":
      "نظام ألواح شينجل أسفلتية معمارية عملي ومراعٍ للتصميم للأسقف السكنية ذات الميل المناسب.",
    "metal-roofing":
      "تقييم ملاءمة السقف المعدني بدرزات قائمة وفق العمارة وهندسة السقف وأولويات الأداء.",
    "flat-roofing":
      "تخطيط أنظمة الأغشية للأسقف المسطحة ومنخفضة الميل مع التركيز على ميل التصريف والاستمرارية وتفاصيل نقاط الانتقال.",
    "roof-inspection-maintenance":
      "توثيق حالة نظام السقف والتفاصيل الأكثر عرضة للضرر، مع أولويات الصيانة أو المراقبة أو الأعمال اللاحقة.",
  },
};

const cityNames: Record<TranslatedLocale, Record<string, string>> = {
  "zh-cn": {
    vancouver: "温哥华",
    burnaby: "本拿比",
    coquitlam: "高贵林",
    surrey: "素里",
    richmond: "列治文",
    "north-vancouver": "北温哥华",
    "west-vancouver": "西温哥华",
    "new-westminster": "新威斯敏斯特",
    "port-coquitlam": "高贵林港",
    "port-moody": "满地宝",
    "maple-ridge": "枫树岭",
    delta: "三角洲",
    langley: "兰里",
    "white-rock": "白石",
  },
  "zh-tw": {
    vancouver: "溫哥華",
    burnaby: "本拿比",
    coquitlam: "高貴林",
    surrey: "素里",
    richmond: "列治文",
    "north-vancouver": "北溫哥華",
    "west-vancouver": "西溫哥華",
    "new-westminster": "新威斯敏斯特",
    "port-coquitlam": "高貴林港",
    "port-moody": "滿地寶",
    "maple-ridge": "楓樹嶺",
    delta: "三角洲",
    langley: "蘭里",
    "white-rock": "白石",
  },
  "pa-in": {
    vancouver: "ਵੈਨਕੂਵਰ",
    burnaby: "ਬਰਨਾਬੀ",
    coquitlam: "ਕੋਕੁਇਟਲਮ",
    surrey: "ਸਰੀ",
    richmond: "ਰਿਚਮੰਡ",
    "north-vancouver": "ਨਾਰਥ ਵੈਨਕੂਵਰ",
    "west-vancouver": "ਵੈਸਟ ਵੈਨਕੂਵਰ",
    "new-westminster": "ਨਿਊ ਵੈਸਟਮਿੰਸਟਰ",
    "port-coquitlam": "ਪੋਰਟ ਕੋਕੁਇਟਲਮ",
    "port-moody": "ਪੋਰਟ ਮੂਡੀ",
    "maple-ridge": "ਮੈਪਲ ਰਿਜ",
    delta: "ਡੈਲਟਾ",
    langley: "ਲੈਂਗਲੀ",
    "white-rock": "ਵਾਈਟ ਰਾਕ",
  },
  "ko-kr": {
    vancouver: "밴쿠버",
    burnaby: "버나비",
    coquitlam: "코퀴틀럼",
    surrey: "서리",
    richmond: "리치먼드",
    "north-vancouver": "노스밴쿠버",
    "west-vancouver": "웨스트밴쿠버",
    "new-westminster": "뉴웨스트민스터",
    "port-coquitlam": "포트코퀴틀럼",
    "port-moody": "포트무디",
    "maple-ridge": "메이플리지",
    delta: "델타",
    langley: "랭리",
    "white-rock": "화이트록",
  },
  "fa-ir": {
    vancouver: "ونکوور",
    burnaby: "برنابی",
    coquitlam: "کوکیتلام",
    surrey: "سوری",
    richmond: "ریچموند",
    "north-vancouver": "نورث ونکوور",
    "west-vancouver": "وست ونکوور",
    "new-westminster": "نیو وست‌مینستر",
    "port-coquitlam": "پورت کوکیتلام",
    "port-moody": "پورت مودی",
    "maple-ridge": "میپل ریج",
    delta: "دلتا",
    langley: "لنگلی",
    "white-rock": "وایت راک",
  },
  "ar-sa": {
    vancouver: "فانكوفر",
    burnaby: "بورنابي",
    coquitlam: "كوكويتلام",
    surrey: "سوري",
    richmond: "ريتشموند",
    "north-vancouver": "نورث فانكوفر",
    "west-vancouver": "ويست فانكوفر",
    "new-westminster": "نيو وستمنستر",
    "port-coquitlam": "بورت كوكويتلام",
    "port-moody": "بورت مودي",
    "maple-ridge": "ميبل ريدج",
    delta: "دلتا",
    langley: "لانغلي",
    "white-rock": "وايت روك",
  },
};

const cityFocus: Record<TranslatedLocale, Record<string, string>> = {
  "zh-cn": {
    vancouver: "关注排水、屋顶交接及温哥华当地要求",
    burnaby: "关注屋顶结构、排水、施工通道及耐久交接细节",
    coquitlam: "关注复杂屋面、坡地环境及暴露条件",
    surrey: "根据住宅屋顶形态、暴露和排水条件进行规划",
    richmond: "关注排水、低坡细节及沿海暴露",
    "north-vancouver": "关注陡坡场地、排水及植被相关维护",
    "west-vancouver": "适用于复杂建筑和暴露场地的细致屋顶规划",
    "new-westminster": "关注较旧屋顶系统、扩建交接及紧凑场地",
    "port-coquitlam": "关注不断变化的住宅屋面形态、扩建和排水连接",
    "port-moody": "关注林木环境、风驱雨及屋顶交接",
    "maple-ridge": "适用于较大地块和山麓住宅场地",
    delta: "根据场地风暴露、排水和屋顶形态进行评估",
    langley: "关注较大屋面、扩建连接及开阔场地暴露",
    "white-rock": "关注沿海暴露、屋顶边缘和排水细节",
  },
  "zh-tw": {
    vancouver: "關注排水、屋頂交接及溫哥華當地要求",
    burnaby: "關注屋頂結構、排水、施工通道及耐久交接細節",
    coquitlam: "關注複雜屋面、坡地環境及暴露條件",
    surrey: "依據住宅屋頂形態、暴露和排水條件進行規劃",
    richmond: "關注排水、低坡細節及沿海暴露",
    "north-vancouver": "關注陡坡場地、排水及植被相關維護",
    "west-vancouver": "適用於複雜建築和暴露場地的細緻屋頂規劃",
    "new-westminster": "關注較舊屋頂系統、擴建交接及緊湊場地",
    "port-coquitlam": "關注不斷變化的住宅屋面形態、擴建和排水連接",
    "port-moody": "關注林木環境、風驅雨及屋頂交接",
    "maple-ridge": "適用於較大地塊和山麓住宅場地",
    delta: "依據場地風暴露、排水和屋頂形態進行評估",
    langley: "關注較大屋面、擴建連接及開闊場地暴露",
    "white-rock": "關注沿海暴露、屋頂邊緣和排水細節",
  },
  "pa-in": {
    vancouver: "ਡਰੇਨੇਜ, ਛੱਤ ਦੇ ਜੋੜਾਂ ਅਤੇ ਵੈਨਕੂਵਰ ਦੀਆਂ ਸਥਾਨਕ ਲੋੜਾਂ ਉੱਤੇ ਧਿਆਨ ਨਾਲ",
    burnaby: "ਛੱਤ ਦੀ ਬਣਤਰ, ਡਰੇਨੇਜ, ਪਹੁੰਚ ਅਤੇ ਟਿਕਾਊ ਜੋੜਾਂ ਉੱਤੇ ਧਿਆਨ ਨਾਲ",
    coquitlam: "ਜਟਿਲ ਛੱਤਾਂ, ਢਲਾਣ ਵਾਲੀਆਂ ਥਾਵਾਂ ਅਤੇ ਖੁੱਲ੍ਹੇ ਮੌਸਮੀ ਪ੍ਰਭਾਵ ਲਈ",
    surrey: "ਘਰ ਦੀ ਛੱਤ ਦੀ ਬਣਤਰ, ਮੌਸਮੀ ਪ੍ਰਭਾਵ ਅਤੇ ਡਰੇਨੇਜ ਅਨੁਸਾਰ",
    richmond: "ਡਰੇਨੇਜ, ਘੱਟ ਢਲਾਣ ਦੇ ਵੇਰਵਿਆਂ ਅਤੇ ਤਟਵਰਤੀ ਪ੍ਰਭਾਵ ਉੱਤੇ ਧਿਆਨ ਨਾਲ",
    "north-vancouver": "ਖੜੀਆਂ ਥਾਵਾਂ, ਡਰੇਨੇਜ ਅਤੇ ਦਰੱਖਤਾਂ ਨਾਲ ਸੰਬੰਧਿਤ ਸੰਭਾਲ ਲਈ",
    "west-vancouver": "ਜਟਿਲ ਆਰਕੀਟੈਕਚਰ ਅਤੇ ਖੁੱਲ੍ਹੀਆਂ ਥਾਵਾਂ ਲਈ ਵਿਸਥਾਰਪੂਰਵਕ ਯੋਜਨਾ",
    "new-westminster": "ਪੁਰਾਣੀਆਂ ਛੱਤਾਂ, ਵਾਧੂ ਬਣਤਰਾਂ ਅਤੇ ਤੰਗ ਥਾਵਾਂ ਉੱਤੇ ਧਿਆਨ ਨਾਲ",
    "port-coquitlam": "ਘਰਾਂ ਦੀ ਬਦਲਦੀ ਛੱਤ ਬਣਤਰ, ਵਾਧਿਆਂ ਅਤੇ ਡਰੇਨੇਜ ਜੋੜਾਂ ਲਈ",
    "port-moody": "ਦਰੱਖਤਾਂ ਵਾਲੀਆਂ ਥਾਵਾਂ, ਹਵਾ ਨਾਲ ਆਉਂਦੀ ਬਾਰਿਸ਼ ਅਤੇ ਛੱਤ ਜੋੜਾਂ ਲਈ",
    "maple-ridge": "ਵੱਡੀਆਂ ਜਾਇਦਾਦਾਂ ਅਤੇ ਪਹਾੜੀ ਪੈਰਾਂ ਵਾਲੀਆਂ ਰਿਹਾਇਸ਼ੀ ਥਾਵਾਂ ਲਈ",
    delta: "ਥਾਂ ਦੇ ਹਵਾ ਪ੍ਰਭਾਵ, ਡਰੇਨੇਜ ਅਤੇ ਛੱਤ ਦੀ ਬਣਤਰ ਅਨੁਸਾਰ",
    langley: "ਵੱਡੀਆਂ ਛੱਤਾਂ, ਵਾਧੂ ਬਣਤਰਾਂ ਅਤੇ ਖੁੱਲ੍ਹੀ ਥਾਂ ਦੇ ਪ੍ਰਭਾਵ ਲਈ",
    "white-rock": "ਤਟਵਰਤੀ ਪ੍ਰਭਾਵ, ਕਿਨਾਰਿਆਂ ਅਤੇ ਪਾਣੀ ਨਿਕਾਸ ਦੇ ਵੇਰਵਿਆਂ ਉੱਤੇ ਧਿਆਨ ਨਾਲ",
  },
  "ko-kr": {
    vancouver: "배수, 지붕 전이부 및 밴쿠버 지역 요건을 고려한",
    burnaby: "지붕 형상, 배수, 접근성 및 내구성 있는 전이부를 고려한",
    coquitlam: "복잡한 지붕면, 경사지 및 노출 환경을 고려한",
    surrey: "주택의 지붕 형태, 노출 및 배수 조건에 맞춘",
    richmond: "배수, 저경사 세부 및 해안 노출을 고려한",
    "north-vancouver": "급경사 부지, 배수 및 수목 관련 유지관리를 고려한",
    "west-vancouver": "복잡한 건축과 노출된 부지를 위한 세심한",
    "new-westminster": "노후 지붕 구성, 증축부 및 좁은 부지를 고려한",
    "port-coquitlam": "변화된 주택 지붕 형태, 증축부 및 배수 연결을 고려한",
    "port-moody": "수목이 많은 부지, 풍우 및 지붕 전이부를 고려한",
    "maple-ridge": "넓은 대지와 산기슭 주거 부지를 위한",
    delta: "부지별 바람 노출, 배수 및 지붕 형태에 맞춘",
    langley: "넓은 지붕면, 증축 연결 및 개방된 부지 노출을 고려한",
    "white-rock": "해안 노출, 지붕 가장자리 및 배수 세부를 고려한",
  },
  "fa-ir": {
    vancouver: "با تمرکز بر زهکشی، نقاط انتقال سقف و الزامات محلی ونکوور",
    burnaby: "با تمرکز بر هندسهٔ سقف، زهکشی، دسترسی و جزئیات بادوام نقاط انتقال",
    coquitlam: "برای سقف‌های پیچیده، زمین‌های شیب‌دار و مناطق بادگیر",
    surrey: "متناسب با فرم سقف خانه، میزان بادگیر بودن و شرایط زهکشی",
    richmond: "با تمرکز بر زهکشی، جزئیات کم‌شیب و شرایط ساحلی",
    "north-vancouver": "برای زمین‌های پرشیب، زهکشی و نگهداری در محیط‌های پردرخت",
    "west-vancouver": "با برنامه‌ریزی دقیق برای معماری پیچیده و مناطق بادگیر",
    "new-westminster": "با تمرکز بر سقف‌های قدیمی‌تر، الحاقات و زمین‌های جمع‌وجور",
    "port-coquitlam": "برای فرم‌های متنوع سقف مسکونی، الحاقات و اتصالات زهکشی",
    "port-moody": "برای محیط‌های پردرخت، باران همراه با باد و نقاط انتقال سقف",
    "maple-ridge": "مناسب زمین‌های بزرگ‌تر و خانه‌های دامنه‌ای",
    delta: "متناسب با بادگیر بودن زمین، زهکشی و فرم سقف",
    langley: "برای سقف‌های بزرگ‌تر، اتصال الحاقات و زمین‌های باز",
    "white-rock": "با تمرکز بر شرایط ساحلی، لبه‌های سقف و جزئیات زهکشی",
  },
  "ar-sa": {
    vancouver: "مع التركيز على التصريف ونقاط انتقال السقف ومتطلبات فانكوفر المحلية",
    burnaby: "مع التركيز على هندسة السقف والتصريف وسهولة الوصول ومتانة نقاط الانتقال",
    coquitlam: "للأسقف المعقدة والمواقع المنحدرة والمناطق المعرّضة للعوامل الجوية",
    surrey: "وفق شكل سقف المنزل ودرجة التعرّض وظروف التصريف",
    richmond: "مع التركيز على التصريف وتفاصيل الميل المنخفض والتعرّض الساحلي",
    "north-vancouver": "للمواقع شديدة الانحدار والتصريف والصيانة المرتبطة بالأشجار",
    "west-vancouver": "بتخطيط دقيق للعمارة المعقدة والمواقع المعرّضة",
    "new-westminster": "مع التركيز على الأسقف الأقدم والملاحق والمواقع الضيقة",
    "port-coquitlam": "لأشكال الأسقف السكنية المتنوعة والملاحق ووصلات التصريف",
    "port-moody": "للمواقع كثيفة الأشجار والأمطار المدفوعة بالرياح ونقاط انتقال السقف",
    "maple-ridge": "مناسب للقطع الأكبر والمنازل الواقعة عند سفوح التلال",
    delta: "وفق تعرّض الموقع للرياح والتصريف وشكل السقف",
    langley: "للأسقف الأكبر ووصلات الملاحق والمواقع المفتوحة",
    "white-rock": "مع التركيز على الظروف الساحلية وحواف السقف وتفاصيل التصريف",
  },
};

export function localizedPageMeta(
  canonicalPath: string,
  locale: LocaleCode,
  fallback: PageMetaCopy,
): PageMetaCopy {
  if (locale === "en-ca") return fallback;

  const expansion = expansionMeta[locale]?.[canonicalPath];
  if (expansion) return expansion;

  const core = coreMeta[locale]?.[canonicalPath];
  if (core) return core;

  const serviceSlug = canonicalPath.slice(1);
  // Prefer English service meta from page definitions for new 20-service catalogue;
  // locale-specific service name maps may still use legacy keys.
  const serviceName = serviceNames[locale]?.[serviceSlug];
  const serviceDescription = serviceDescriptions[locale]?.[serviceSlug];
  if (serviceName && serviceDescription) {
    return {
      title: serviceTitle(locale, serviceName),
      description: serviceDescription,
    };
  }

  const citySlug = canonicalPath.startsWith("/service-areas/")
    ? canonicalPath.slice("/service-areas/".length)
    : "";
  const cityName = cityNames[locale]?.[citySlug];
  const focus = cityFocus[locale]?.[citySlug];
  if (cityName && focus) {
    return {
      title: cityTitle(locale, cityName),
      description: cityDescription(locale, cityName, focus),
    };
  }

  return fallback;
}

function serviceTitle(locale: TranslatedLocale, serviceName: string): string {
  switch (locale) {
    case "zh-cn":
    case "zh-tw":
      return `${serviceName}（大溫哥華）｜Revolin Roofing`.replace(
        "大溫哥華",
        locale === "zh-cn" ? "大温哥华" : "大溫哥華",
      );
    case "pa-in":
      return `${serviceName} - ਮੈਟਰੋ ਵੈਨਕੂਵਰ | Revolin Roofing`;
    case "ko-kr":
      return `메트로 밴쿠버 ${serviceName} | Revolin Roofing`;
    case "fa-ir":
      return `${serviceName} در مترو ونکوور | رولین روفینگ`;
    case "ar-sa":
      return `${serviceName} في مترو فانكوفر | رولين روفينغ`;
    default:
      return `${serviceName} | Revolin Roofing`;
  }
}

function cityTitle(locale: TranslatedLocale, cityName: string): string {
  switch (locale) {
    case "zh-cn":
      return `${cityName}屋顶服务｜Revolin Roofing`;
    case "zh-tw":
      return `${cityName}屋頂服務｜Revolin Roofing`;
    case "pa-in":
      return `${cityName} ਵਿੱਚ ਰੂਫਿੰਗ ਸੇਵਾਵਾਂ | Revolin Roofing`;
    case "ko-kr":
      return `${cityName} 지붕 서비스 | Revolin Roofing`;
    case "fa-ir":
      return `خدمات سقف در ${cityName} | رولین روفینگ`;
    case "ar-sa":
      return `خدمات التسقيف في ${cityName} | رولين روفينغ`;
    default:
      return `${cityName} | Revolin Roofing`;
  }
}

function cityDescription(locale: TranslatedLocale, cityName: string, focus: string): string {
  switch (locale) {
    case "zh-cn":
      return `为${cityName}住宅提供屋顶检查、维修及更换规划，${focus}。`;
    case "zh-tw":
      return `為${cityName}住宅提供屋頂檢查、維修及更換規劃，${focus}。`;
    case "pa-in":
      return `${cityName} ਦੇ ਘਰਾਂ ਲਈ ਛੱਤ ਦੀ ਜਾਂਚ, ਮੁਰੰਮਤ ਅਤੇ ਬਦਲੀ ਦੀ ਯੋਜਨਾ, ${focus}।`;
    case "ko-kr":
      return `${cityName} 주택의 지붕 점검, 수리 및 교체 계획으로, ${focus} 접근입니다.`;
    case "fa-ir":
      return `برنامه‌ریزی بازرسی، تعمیر و تعویض سقف برای خانه‌های ${cityName}، ${focus}.`;
    case "ar-sa":
      return `تخطيط فحص السقف وإصلاحه واستبداله لمنازل ${cityName}، ${focus}.`;
    default:
      return `${cityName}: ${focus}`;
  }
}
